var _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuturaCyrillicMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20190801 at Wed Dec 29 15:16:14 2021\n By www-data\nCopyright (c) 1995 ParaGraph Intl., (c) 1998 ParaType Inc., ParaType Ltd. All rights reserved.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "FuturaCyrillicMedium",
    horizAdvX: 500
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "FuturaCyrillicMedium",
    fontWeight: 450,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 6 2 2 2 4 2 3 3",
    ascent: 763,
    descent: -237,
    xHeight: 421,
    capHeight: 667,
    bbox: "-362 -270 1167 920",
    underlineThickness: 50,
    underlinePosition: -100,
    unicodeRange: "U+0020-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10017.var.accented",
    unicode: "\u0410`",
    horizAdvX: 656,
    d: "M542 0l-70 161h-285l-73 -161h-110l332 706l316 -706h-110zM229 257h202l-99 226zM312 727l-48 40l138 139l86 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10022.var.accented",
    unicode: "\u0415`",
    d: "M448 667v-96h-266v-169h258v-96h-258v-210h266v-96h-368v667h368zM234 727l-48 40l138 139l86 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10026.var.accented",
    unicode: "\u0418`",
    horizAdvX: 712,
    d: "M530 0v449l-450 -479v697h102v-451l450 479v-695h-102zM340 727l-48 40l138 139l86 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10032.var.accented",
    unicode: "\u041E`",
    horizAdvX: 790,
    d: "M395 679q149 0 248 -99t99 -247t-99 -247t-248 -99t-248 99t-99 247t99 247t248 99zM395 81q107 0 176 70.5t69 181.5t-69 181.5t-176 70.5t-176 -70.5t-69 -181.5t69 -181.5t176 -70.5zM379 727l-48 40l138 139l86 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10037.var.accented",
    unicode: "\u0423`",
    horizAdvX: 570,
    d: "M6 667h124l172 -356l156 356h106l-301 -667h-106l86 189zM269 727l-48 40l138 139l86 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10045.var.accented",
    unicode: "\u042B`",
    horizAdvX: 740,
    d: "M80 0v667h102v-269h76q107 0 167 -53q63 -55 63 -147q0 -48 -21.5 -91.5t-61.5 -70.5q-54 -36 -146 -36h-179zM182 302v-206h72q134 0 134 101q0 44 -29.5 74.5t-102.5 30.5h-74zM558 667h102v-667h-102v667zM354 727l-48 40l138 139l86 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10047.var.accented",
    unicode: "\u042D`",
    horizAdvX: 622,
    d: "M48 511v120q84 48 193 48q146 0 234 -87q99 -98 99 -258q0 -157 -99 -256q-91 -91 -237 -91q-106 0 -190 50v121q76 -77 190 -77q102 0 162 60t68 149h-330v96h328q-9 81 -61 135q-62 64 -166 64q-108 0 -191 -74zM239 727l-48 40l138 139l86 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10048.var.accented",
    unicode: "\u042E`",
    horizAdvX: 1000,
    d: "M182 402h100q17 104 89 178q97 99 244 99q146 0 241.5 -99t95.5 -247t-96 -247t-241 -99q-166 0 -261 117q-69 86 -72 202h-100v-306h-102v667h102v-265zM615 81q103 0 169 71t66 181t-66 181t-169 71t-169 -71t-66 -181t66 -181t169 -71zM484 727l-48 40l138 139l86 -60 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10049.var.accented",
    unicode: "\u042F`",
    horizAdvX: 534,
    d: "M20 0l198 278q-59 7 -103 45q-57 50 -57 142q0 84 51 139q27 29 64 44t60 17t57 2h164v-667h-102v267h-24l-182 -267h-126zM352 573h-50q-82 0 -114 -31q-32 -30 -32 -77q0 -54 38 -80q36 -24 102 -24h56v212zM251 727l-48 40l138 139l86 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10023.var.accented",
    unicode: "\u0401`",
    d: "M448 667v-96h-266v-169h258v-96h-258v-210h266v-96h-368v667h368zM219 738l-33 29l111 139l63 -46zM63 802q0 19 15 37t41 18q24 0 40 -16t16 -39q0 -24 -16 -40t-40 -16q-26 0 -41 18t-15 38zM353 802q0 23 16 39t40 16q26 0 41 -18t15 -37q0 -20 -15 -38t-41 -18 q-24 0 -40 16t-16 40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10065.var.accented",
    unicode: "\u0430`",
    horizAdvX: 530,
    d: "M370 372v49h98v-421h-98v44q-49 -57 -126 -57q-93 0 -148.5 66t-55.5 158q0 100 59.5 160.5t145.5 60.5q79 0 125 -60zM257 344q-52 0 -84.5 -39t-32.5 -96q0 -56 32.5 -95t84.5 -39q50 0 84.5 35t34.5 98q0 65 -34.5 100.5t-84.5 35.5zM340 675l90 -46l-156 -144l-54 34 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10070.var.accented",
    unicode: "\u0435`",
    horizAdvX: 482,
    d: "M357 142l82 -46q-28 -50 -71 -77q-49 -32 -124 -32q-88 0 -142 54q-62 62 -62 161q0 104 67 173q57 57 141 57q82 0 135 -55q59 -61 59 -178v-12h-302q4 -53 36 -85q27 -27 75 -27q39 0 67 21q23 18 39 46zM147 267h195q-6 35 -30 57q-26 24 -66 24q-42 0 -69 -27 q-22 -20 -30 -54zM318 675l90 -46l-156 -144l-54 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10074.var.accented",
    unicode: "\u0438`",
    horizAdvX: 510,
    d: "M62 421h98v-239l288 277v-459h-98v245l-288 -277v453zM330 675l90 -46l-156 -144l-54 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10080.var.accented",
    unicode: "\u043E`",
    horizAdvX: 530,
    d: "M265 432q96 0 160.5 -62.5t64.5 -159.5q0 -96 -64.5 -159.5t-160.5 -63.5t-160.5 63.5t-64.5 159.5q0 97 64.5 159.5t160.5 62.5zM265 75q57 0 91 36.5t34 97.5q0 67 -36.5 101t-88.5 34t-88.5 -34t-36.5 -101q0 -61 34 -97.5t91 -36.5zM340 675l90 -46l-156 -144l-54 34 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10085.var.accented",
    unicode: "\u0443`",
    horizAdvX: 482,
    d: "M31 -229l155 295l-180 355h118l120 -246l122 246h110l-335 -650h-110zM316 675l90 -46l-156 -144l-54 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10093.var.accented",
    unicode: "\u044B`",
    horizAdvX: 580,
    d: "M62 0v421h98v-149h56q27 0 44 -1.5t41 -11.5t42 -30q33 -37 33 -92q0 -63 -38 -101q-17 -17 -40.5 -25.5t-39 -9.5t-43.5 -1h-153zM160 84h45q36 0 51 9q22 16 22 43q0 28 -21 42q-16 10 -51 10h-46v-104zM420 0v421h98v-421h-98zM365 675l90 -46l-156 -144l-54 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10095.var.accented",
    unicode: "\u044D`",
    horizAdvX: 428,
    d: "M40 317v93q56 22 119 22q106 0 168 -62q61 -61 61 -159t-62 -161q-60 -63 -157 -63q-68 0 -129 24v93q51 -29 115 -29q61 0 95 34q25 25 31 65h-195v82h192q-8 45 -42 67q-30 21 -81 21q-60 0 -115 -27zM223 675l90 -46l-156 -144l-54 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10096.var.accented",
    unicode: "\u044E`",
    horizAdvX: 700,
    d: "M160 265h67q10 59 55 105q62 62 157 62q94 0 157.5 -62.5t63.5 -159.5q0 -96 -63.5 -159.5t-157.5 -63.5q-100 0 -162 67q-46 50 -52 121h-65v-175h-98v421h98v-156zM439 344q-51 0 -86 -34t-35 -101t35 -100.5t86 -33.5t86 33.5t35 100.5t-35 101t-86 34zM425 675 l90 -46l-156 -144l-54 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10097.var.accented",
    unicode: "\u044F`",
    horizAdvX: 418,
    d: "M8 0l132 167q-39 6 -67 32q-35 34 -35 87q0 60 39 97q40 38 122 38h157v-421h-98v155h-20l-115 -155h-115zM258 235v102h-57q-35 0 -51 -9q-24 -15 -24 -42t20 -41q15 -10 54 -10h58zM284 675l90 -46l-156 -144l-54 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10071.var.accented",
    unicode: "\u0451`",
    horizAdvX: 482,
    d: "M357 142l82 -46q-28 -50 -71 -77q-49 -32 -124 -32q-88 0 -142 54q-62 62 -62 161q0 104 67 173q57 57 141 57q82 0 135 -55q59 -61 59 -178v-12h-302q4 -53 36 -85q27 -27 75 -27q39 0 67 21q23 18 39 46zM147 267h195q-6 35 -30 57q-26 24 -66 24q-42 0 -69 -27 q-22 -20 -30 -54zM265 675l74 -37l-144 -144l-38 25zM52 575q0 24 15.5 40t39.5 16t40 -16t16 -40q0 -26 -18 -41t-38 -15t-37.5 15.5t-17.5 40.5zM322 575q0 24 16 40t40 16q26 0 41 -18t15 -38q0 -23 -17 -39.5t-39 -16.5q-20 0 -38 15t-18 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 470,
    d: "M268 331h-106v-331h-98v331h-34v90h34v140q0 78 26 115q46 65 146 65q104 0 146 -65q26 -42 26 -115v-29h-98v18q0 45 -12 65q-19 32 -62 32q-44 0 -62 -32q-12 -19 -12 -65v-129h106v-90zM310 421h98v-421h-98v421z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 470,
    d: "M268 331h-106v-331h-98v331h-34v90h34v140q0 78 26 115q46 65 146 65q104 0 146 -65q26 -40 26 -115v-561h-98v550q0 43 -12 65q-18 32 -62 32t-62 -32q-12 -19 -12 -65v-129h106v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 252,
    d: "M175 165h-98v502h98v-502zM66 48q0 25 17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5t-42.5 17.5t-17.5 42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 366,
    d: "M156 667l-18 -268h-72l-18 268h108zM318 667l-18 -268h-72l-18 268h108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 600,
    d: "M407 0h-98l31 196h-114l-31 -196h-98l31 196h-108l14 88h108l18 112h-108l14 88h108l29 183h98l-29 -183h114l29 183h98l-29 -183h108l-14 -88h-108l-18 -112h108l-14 -88h-108zM354 284l18 112h-114l-18 -112h114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 568,
    d: "M476 567l-82 -48q-10 24 -30 42q-28 24 -72 24q-47 0 -74 -27q-20 -20 -20 -51q0 -34 26 -56q20 -17 63 -34l50 -20q76 -31 111 -70q46 -51 46 -126q0 -90 -58 -152q-46 -49 -110 -58v-101h-74v98q-77 6 -130 66q-49 55 -56 130l101 22q0 -48 28 -85q32 -40 87 -40 q48 0 79 32q31 31 31 80q0 43 -29 73q-19 20 -67 41l-64 27q-58 25 -94 61q-42 43 -42 102q0 80 51 129q43 41 105 50v89h74v-88q48 -4 87 -33q41 -32 63 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 810,
    d: "M194 673q66 0 113.5 -46.5t47.5 -110.5t-47.5 -110.5t-113.5 -46.5t-113.5 46.5t-47.5 110.5t47.5 110.5t113.5 46.5zM194 431q39 0 61 26.5t22 58.5t-22 58.5t-61 26.5t-61 -26.5t-22 -58.5t22 -58.5t61 -26.5zM191 18l381 660l47 -27l-381 -662zM616 307 q66 0 113.5 -46.5t47.5 -110.5t-47.5 -110.5t-113.5 -46.5t-113.5 46.5t-47.5 110.5t47.5 110.5t113.5 46.5zM616 65q39 0 61 26.5t22 58.5t-22 58.5t-61 26.5t-61 -26.5t-22 -58.5t22 -58.5t61 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 646,
    d: "M537 313l65 -68l-79 -91l123 -154h-124l-66 82q-26 -27 -56 -49q-65 -46 -146 -46q-92 0 -146 54t-54 137q0 60 25 99t71 73q30 22 53 37q-66 66 -66 138q0 63 40.5 108.5t117.5 45.5q75 0 117.5 -43t42.5 -101q0 -48 -29 -87q-26 -34 -83 -77l118 -144zM395 154 l-132 160q-46 -25 -73 -55q-36 -39 -36 -85q0 -42 29 -71.5t75 -29.5q36 0 75 26q25 17 62 55zM284 442l37 27q40 28 40 66q0 24 -16.5 42t-49.5 18q-30 0 -47 -16.5t-17 -42.5q0 -31 23 -58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 204,
    d: "M156 667l-18 -268h-72l-18 268h108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 324,
    d: "M264 -142l-90 -35q-43 92 -68 202q-26 116 -26 255q0 140 28 265q24 106 66 195l90 -35q-41 -92 -60 -181q-24 -108 -24 -244q0 -131 23 -236q22 -93 61 -186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 324,
    d: "M150 -177l-90 35q39 93 61 186q23 105 23 236q0 136 -24 244q-19 89 -60 181l90 35q42 -89 66 -195q28 -125 28 -265q0 -139 -26 -255q-25 -110 -68 -202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 550,
    d: "M136 655l107 -45l-7 119h78l-8 -118l108 44l25 -72l-114 -28l74 -90l-60 -47l-64 97l-64 -97l-60 47l74 88l-114 28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    d: "M33 291v90h170v170h94v-170h170v-90h-170v-170h-94v170h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 320,
    d: "M10 -129l102 254l88 -34l-124 -247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 340,
    d: "M50 162v102h240v-102h-240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 252,
    d: "M66 48q0 25 17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5t-42.5 17.5t-17.5 42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 684,
    d: "M0 -177l526 942l80 -36l-526 -942z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 568,
    d: "M284 -11q-88 0 -151 72q-85 97 -85 272q0 176 85 273q63 72 151 72t151 -72q85 -97 85 -273q0 -175 -85 -272q-63 -72 -151 -72zM284 588q-54 0 -90 -55q-46 -68 -46 -199q0 -130 46 -200q36 -55 90 -55t90 55q46 70 46 200q0 131 -46 199q-36 55 -90 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 568,
    d: "M250 0v573h-116l56 94h162v-667h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 568,
    d: "M482 94v-94h-448l231 280q52 63 80 104q35 52 35 96q0 45 -29 76.5t-82 31.5t-84 -35t-34 -86h-98q4 88 56 146q58 65 156 65q101 0 158 -59t57 -142q0 -69 -48 -140q-26 -39 -95 -120l-104 -123h249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 568,
    d: "M166 497h-98q4 79 57 130t146 51q91 0 144 -55q48 -49 48 -127q0 -50 -23 -88q-23 -36 -60 -56q42 -16 66 -53q28 -41 28 -103q0 -92 -57 -149q-58 -58 -163 -58q-97 0 -149 56q-49 52 -57 136h98q8 -45 36 -72q32 -30 81 -30q47 0 78 28q35 33 35 94q0 50 -30 79 q-31 30 -86 30h-20v86h14q56 0 85 29q26 26 26 71q0 41 -26 67q-26 25 -71 25q-48 0 -74 -27q-10 -11 -17 -26.5t-9 -24.5t-2 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 568,
    d: "M448 716v-496h72v-94h-72v-126h-98v126h-330zM198 218h152v215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 568,
    d: "M477 667v-94h-206l-33 -111q20 2 31 2q94 0 154 -59q65 -63 65 -171q0 -109 -68 -177q-69 -68 -185 -68q-76 0 -128 30q-48 29 -79 77l77 64q14 -34 51 -58q34 -23 87 -23q63 0 102 37q43 43 43 113t-40 108q-39 37 -109 37q-40 0 -78 -14q-34 -13 -59 -30l99 337h276z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 568,
    d: "M348 690l74 -55l-159 -201q20 4 42 4q94 0 154 -62q59 -62 59 -156q0 -103 -66 -168q-64 -63 -172 -63q-109 0 -172 65q-58 61 -58 151q0 66 32 128q7 14 14.5 26.5t17 26.5t14.5 20.5t18.5 24t16.5 21.5zM285 351q-57 0 -96 -37t-39 -99q0 -61 39 -99q39 -37 96 -37 t94 37q39 39 39 99t-39 99q-37 37 -94 37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 568,
    d: "M50 27l332 546h-328v94h496l-420 -690z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 568,
    d: "M284 303q-48 0 -79 -31t-31 -81q0 -45 30 -78q30 -34 80 -34t80 34q30 33 30 78q0 50 -31 81t-79 31zM284 588q-44 0 -73 -27q-28 -28 -28 -74q0 -43 27 -70q28 -30 74 -30t74 30q27 27 27 70q0 46 -28 74q-29 27 -73 27zM394 347q45 -19 70 -54q30 -40 30 -100 q0 -87 -53 -142q-58 -62 -157 -62t-157 62q-53 55 -53 142q0 60 30 100q25 35 70 54q-36 15 -59 50q-24 38 -24 91q0 85 56 139q54 51 137 51t137 -51q56 -54 56 -139q0 -53 -24 -91q-23 -35 -59 -50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 568,
    d: "M220 -23l-74 55l157 201q-17 -4 -36 -4q-94 0 -156 62q-61 61 -61 152q0 99 66 167t172 68q108 0 172 -66q58 -60 58 -151q0 -65 -32 -127q-7 -14 -14.5 -26.5t-17 -26.5t-14.5 -20.5t-18.5 -24t-16.5 -21.5zM283 316q57 0 96 40q39 41 39 99t-39 95q-40 38 -95 38 t-95 -38q-39 -39 -39 -98q0 -60 39 -99q39 -37 94 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 252,
    d: "M66 372q0 25 17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5t-42.5 17.5t-17.5 42.5zM66 47q0 25 17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5t-42.5 17.5t-17.5 42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 320,
    d: "M90 372q0 25 17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5t-42.5 17.5t-17.5 42.5zM10 -129l102 254l88 -34l-124 -247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    d: "M137 332l330 -156v-96l-434 211v82l434 211v-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    d: "M33 380v84h434v-84h-434zM33 218v84h434v-84h-434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    d: "M363 332l-330 156v96l434 -211v-82l-434 -211v96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 434,
    d: "M158 485h-102q-2 23 -2 34q0 75 45 118q44 42 117 42q75 0 121 -44q43 -41 43 -112q0 -81 -59 -123q-21 -15 -70 -35l-30 -12q-30 -12 -40 -22q-15 -15 -15 -36q0 -25 17 -39q12 -10 30 -10q24 0 38 15q16 17 16 53h98q0 -70 -44 -116q-42 -42 -109 -42q-62 0 -105 41 q-41 41 -41 106q0 51 32 86q24 26 87 51q59 23 73 35q22 21 22 50q0 30 -17 47t-46 17q-30 0 -46 -18q-17 -17 -17 -53q0 -13 4 -33zM158 47q0 25 17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5t-42.5 17.5t-17.5 42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 732,
    d: "M474 439l10 52h68l-39 -201q-6 -30 -6 -45q0 -21 10 -30.5t22 -9.5q32 0 60 40q17 24 26 64t9 71q0 93 -64.5 165t-184.5 72q-121 0 -204 -83t-83 -206q0 -88 46 -159t126 -101q50 -20 114 -20q110 0 203 41l17 -62q-94 -39 -215 -39q-148 0 -242 81q-113 99 -113 260 q0 151 99 249.5t249 98.5q135 0 225.5 -80.5t90.5 -215.5q0 -106 -48 -170q-48 -63 -115 -63q-31 0 -50.5 17t-25.5 45q-44 -68 -124 -68q-52 0 -96.5 38.5t-44.5 121.5q0 93 54 147t121 54q76 0 105 -64zM345 212q43 0 75.5 38t32.5 97q0 43 -22 64.5t-54 21.5 q-44 0 -75 -35t-31 -95q0 -44 21.5 -67.5t52.5 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 656,
    d: "M542 0l-70 161h-285l-73 -161h-110l332 706l316 -706h-110zM229 257h202l-99 226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 526,
    d: "M80 667h101q68 0 110 -11t74 -41q53 -50 53 -132q0 -47 -20 -79q-18 -31 -50 -46q52 -13 86 -48q44 -46 44 -125q0 -73 -44 -120q-62 -65 -187 -65h-167v667zM182 571v-191h31q56 0 83 26q26 25 26 76q0 41 -24 64q-26 25 -81 25h-35zM182 296v-200h62q69 0 101 26 q33 26 33 74q0 43 -27 70q-31 30 -105 30h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 620,
    d: "M574 631v-120q-82 74 -181 74q-108 0 -175.5 -71.5t-67.5 -182.5q0 -107 69 -178.5t175 -71.5q99 0 180 77v-121q-84 -50 -183 -50q-139 0 -236 92q-107 100 -107 252q0 160 107 261q92 87 241 87q103 0 178 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 644,
    d: "M80 667h140q79 0 138 -13.5t110 -51.5q61 -46 94.5 -116t33.5 -153q0 -175 -134 -269q-54 -38 -110 -51t-134 -13h-138v667zM182 571v-475h44q114 0 177 47q91 69 91 190q0 62 -25.5 113t-64.5 79q-64 46 -178 46h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    d: "M448 667v-96h-266v-169h258v-96h-258v-210h266v-96h-368v667h368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 450,
    d: "M414 667v-96h-232v-169h224v-96h-224v-306h-102v667h334z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 748,
    d: "M425 253v94h275v-5q0 -174 -99 -270q-88 -85 -227 -85t-227 91q-99 102 -99 252q0 75 27 140.5t70 108.5q45 45 110.5 72.5t140.5 27.5q99 0 174 -42q69 -39 108 -100l-81 -57q-36 50 -82 76q-49 29 -118 29q-107 0 -176 -69q-33 -33 -52 -83t-19 -104q0 -107 69 -181 q63 -67 167 -67q89 0 149 59q49 48 56 113h-166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 650,
    d: "M182 667v-264h286v264h102v-667h-102v307h-286v-307h-102v667h102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 262,
    d: "M80 667h102v-667h-102v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 362,
    d: "M180 667h102v-432q0 -102 -25 -152q-48 -96 -157 -96q-66 0 -118 34l50 86q28 -24 70 -24q49 0 67 45q11 28 11 107v432z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 586,
    d: "M182 667v-266l258 266h134l-301 -302l303 -365h-136l-238 296l-20 -20v-276h-102v667h102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 394,
    d: "M80 667h102v-571h196v-96h-298v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 852,
    d: "M164 0h-104l140 717l232 -518l234 518l126 -717h-104l-68 402l-194 -433l-192 434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 746,
    d: "M182 0h-102v712l484 -507v462h102v-708l-484 507v-466z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 790,
    d: "M395 679q149 0 248 -99t99 -247t-99 -247t-248 -99t-248 99t-99 247t99 247t248 99zM395 81q107 0 176 70.5t69 181.5t-69 181.5t-176 70.5t-176 -70.5t-69 -181.5t69 -181.5t176 -70.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 480,
    d: "M80 667h147q92 0 146 -36q40 -27 61.5 -70.5t21.5 -91.5q0 -90 -65 -146q-61 -52 -163 -52h-46v-271h-102v667zM182 573v-208h46q64 0 97 28.5t33 76.5q0 17 -4.5 32t-17 32.5t-40.5 28t-69 10.5h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 790,
    d: "M632 -13l-50 50q-79 -50 -187 -50q-150 0 -248.5 98.5t-98.5 247.5q0 148 99 247t248 99t248 -99.5t99 -246.5q0 -140 -92 -239l108 -107h-126zM479 264l102 -101q59 68 59 170q0 111 -69 181.5t-176 70.5t-176 -70.5t-69 -181.5t69 -181.5t176 -70.5q65 0 115 26 l-158 157h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 534,
    d: "M80 667h119q118 0 176 -39q79 -53 79 -157q0 -71 -40.5 -121t-107.5 -65l208 -285h-123l-191 273h-18v-273h-102v667zM182 573v-212h32q13 0 26 1t35.5 7t39 16.5t29 32.5t12.5 52q0 103 -139 103h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 516,
    d: "M450 567l-82 -48q-10 24 -30 42q-30 24 -72 24q-45 0 -69.5 -23t-24.5 -57q0 -52 72 -81l67 -27q157 -64 157 -196q0 -95 -60.5 -154.5t-154.5 -59.5q-97 0 -157 67q-49 55 -56 130l101 22q0 -48 28 -85q32 -40 87 -40q47 0 78.5 31t31.5 81q0 46 -26.5 71t-69.5 43 l-64 27q-136 57 -136 169q0 72 52.5 124t142.5 52q81 0 134 -45q31 -28 51 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 428,
    d: "M418 571h-153v-571h-102v571h-153v96h408v-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 654,
    d: "M80 667h102v-402q0 -78 21 -115q17 -28 50 -48.5t74 -20.5t74 20.5t50 48.5q21 37 21 115v402h102v-429q0 -105 -62 -173q-72 -78 -185 -78t-185 78q-62 68 -62 173v429z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 600,
    d: "M4 667h110l186 -465l186 465h110l-296 -710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 940,
    d: "M4 667h110l176 -446l180 478l174 -478l182 446h110l-298 -710l-174 473l-176 -473z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 546,
    d: "M10 0l210 348l-184 319h114l130 -226l133 226h114l-192 -319l201 -348h-114l-146 255l-152 -255h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 540,
    d: "M219 0v288l-219 379h116l154 -267l154 267h116l-219 -379v-288h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 554,
    d: "M524 667l-328 -571h320v-96h-486l328 571h-274v96h440z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 316,
    d: "M270 639h-84v-726h84v-90h-182v906h182v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 684,
    d: "M684 -177l-80 -36l-526 942l80 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 316,
    d: "M46 -87h84v726h-84v90h182v-906h-182v90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    d: "M250 590l-130 -240h-104l171 317h126l171 -317h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 400,
    d: "M0 -144v86h400v-86h-400z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    d: "M241 485l-156 144l90 46l120 -156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 530,
    d: "M370 372v49h98v-421h-98v44q-49 -57 -126 -57q-93 0 -148.5 66t-55.5 158q0 100 59.5 160.5t145.5 60.5q79 0 125 -60zM257 344q-52 0 -84.5 -39t-32.5 -96q0 -56 32.5 -95t84.5 -39q50 0 84.5 35t34.5 98q0 65 -34.5 100.5t-84.5 35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 530,
    d: "M160 729v-357q46 60 125 60q86 0 145.5 -60.5t59.5 -160.5q0 -92 -55.5 -158t-148.5 -66q-77 0 -126 57v-44h-98v729h98zM273 344q-50 0 -84.5 -35.5t-34.5 -100.5q0 -63 34.5 -98t84.5 -35q52 0 84.5 39t32.5 95q0 57 -32.5 96t-84.5 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 420,
    d: "M388 402v-110q-53 52 -119 52q-56 0 -93 -37q-36 -36 -36 -97q0 -63 38 -101q36 -34 89 -34q73 0 121 54v-109q-53 -33 -128 -33q-101 0 -160 62q-60 62 -60 158q0 99 64 163q62 62 169 62q61 0 115 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 530,
    d: "M370 372v357h98v-729h-98v44q-49 -57 -126 -57q-93 0 -148.5 66t-55.5 158q0 100 59.5 160.5t145.5 60.5q79 0 125 -60zM257 344q-52 0 -84.5 -39t-32.5 -96q0 -56 32.5 -95t84.5 -39q50 0 84.5 35t34.5 98q0 65 -34.5 100.5t-84.5 35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 482,
    d: "M357 142l82 -46q-28 -50 -71 -77q-49 -32 -124 -32q-88 0 -142 54q-62 62 -62 161q0 104 67 173q57 57 141 57q82 0 135 -55q59 -61 59 -178v-12h-302q4 -53 36 -85q27 -27 75 -27q39 0 67 21q23 18 39 46zM147 267h195q-6 35 -30 57q-26 24 -66 24q-42 0 -69 -27 q-22 -20 -30 -54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 270,
    d: "M276 331h-106v-331h-98v331h-42v90h42v146q0 88 41 132q39 41 100 41q35 0 63 -12v-97q-25 15 -47 15q-28 0 -43 -16q-16 -16 -16 -50v-159h106v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 530,
    d: "M370 375v46h98v-387q0 -82 -14 -133.5t-55 -85.5q-55 -45 -140 -45q-86 0 -138 52q-51 51 -62 131h95q7 -40 31 -66q27 -29 76 -29t77 28q32 31 32 106v55q-47 -60 -128 -60q-85 0 -139 57q-63 66 -63 167t62 163q57 58 143 58q77 0 125 -57zM257 344q-45 0 -74 -28 q-43 -40 -43 -107q0 -69 42 -106q32 -28 75 -28q49 0 82 34q37 40 37 99q0 68 -40 106q-30 30 -79 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 486,
    d: "M62 0v729h98v-344q46 47 113 47q84 0 124 -57q27 -39 27 -117v-258h-98v249q0 52 -19 73q-20 22 -55 22q-48 0 -72 -35q-20 -29 -20 -106v-203h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 222,
    d: "M62 421h98v-421h-98v421zM48 595q0 27 18 45t45 18t45 -18t18 -45t-18 -45t-45 -18t-45 18t-18 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 222,
    d: "M62 421h98v-650h-98v650zM48 595q0 27 18 45t45 18t45 -18t18 -45t-18 -45t-45 -18t-45 18t-18 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 442,
    d: "M62 729h98v-449l137 141h130l-181 -175l194 -246h-124l-138 180l-18 -18v-162h-98v729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 222,
    d: "M62 729h98v-729h-98v729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 702,
    d: "M62 0v421h98v-39q41 50 104 50q73 0 109 -62q43 62 125 62t120 -66q22 -38 22 -106v-260h-98v232q0 55 -9 75q-14 37 -56 37q-36 0 -58 -31q-19 -27 -19 -96v-217h-98v232q0 55 -9 75q-14 37 -56 37q-36 0 -58 -31q-19 -27 -19 -96v-217h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 485,
    d: "M61 0v421h98v-39q45 50 114 50q83 0 124 -57q26 -37 26 -117v-258h-98v234q0 38 -6 62t-19 33.5t-23.5 12t-28.5 2.5q-21 0 -33.5 -3.5t-27 -16t-21.5 -43t-7 -79.5v-202h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 530,
    d: "M265 432q96 0 160.5 -62.5t64.5 -159.5q0 -96 -64.5 -159.5t-160.5 -63.5t-160.5 63.5t-64.5 159.5q0 97 64.5 159.5t160.5 62.5zM265 75q57 0 91 36.5t34 97.5q0 67 -36.5 101t-88.5 34t-88.5 -34t-36.5 -101q0 -61 34 -97.5t91 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 530,
    d: "M160 49v-278h-98v650h98v-46q48 57 125 57q86 0 145.5 -60.5t59.5 -158.5q0 -101 -62 -163.5t-142 -62.5q-75 0 -126 62zM273 344q-50 0 -84.5 -35.5t-34.5 -100.5q0 -63 34.5 -98t84.5 -35q52 0 84.5 39t32.5 95q0 57 -32.5 96t-84.5 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 530,
    d: "M370 375v46h98v-650h-98v276q-49 -60 -126 -60q-94 0 -149 66t-55 158q0 100 59.5 160.5t145.5 60.5q77 0 125 -57zM257 344q-52 0 -84.5 -39t-32.5 -96q0 -56 32.5 -95t84.5 -39q50 0 84.5 35t34.5 98q0 65 -34.5 100.5t-84.5 35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 332,
    d: "M62 0v421h98v-38q19 22 41 35q24 14 60 14q43 0 77 -20l-40 -89q-24 15 -50 15q-39 0 -61 -23q-27 -29 -27 -97v-218h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 360,
    d: "M319 358l-73 -48q-22 36 -60 36q-19 0 -30 -11q-9 -9 -9 -22q0 -15 14 -24q3 -2 6 -3.5l11 -5.5l16 -8l50 -25q42 -21 59 -39q31 -31 31 -78q0 -56 -37 -96q-43 -47 -118 -47q-56 0 -91 27q-38 28 -54 77l80 38q10 -29 23 -40q16 -16 43 -16q26 0 40 14t14 33 q0 18 -13 32q-14 14 -42 26l-36 17q-42 20 -58 36q-30 29 -30 71q0 53 35 90q38 40 103 40q45 0 78 -22q30 -19 48 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 242,
    d: "M238 331h-75v-331h-98v331h-41v90h41v154h98v-154h75v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 484,
    d: "M62 421h98v-241q0 -53 18 -76q22 -29 64 -29t64 29q18 23 18 76v241h98v-244q0 -93 -45 -138q-52 -52 -137 -52q-82 0 -133 52q-45 45 -45 138v244z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 448,
    d: "M6 421h110l108 -240l108 240h110l-218 -451z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 686,
    d: "M6 421h110l109 -241l118 277l118 -277l109 241h110l-219 -451l-118 269l-118 -269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 496,
    d: "M6 0l186 228l-150 193h116l93 -123l94 123h120l-155 -193l180 -228h-118l-121 157l-125 -157h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 482,
    d: "M31 -229l155 295l-180 355h118l120 -246l122 246h110l-335 -650h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 480,
    d: "M472 421l-271 -331h250v-90h-443l273 331h-215v90h406z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    d: "M288 565v-168q0 -49 -12 -74q-16 -32 -50 -47q34 -15 50 -47q12 -25 12 -74v-168q0 -47 17 -64q17 -16 71 -16h8v-84h-47q-71 0 -103 24q-44 33 -44 115v191q0 73 -56 83v80q56 10 56 83v191q0 82 44 115q32 24 103 24h47v-84h-8q-54 0 -71 -16q-17 -17 -17 -64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    d: "M202 -250v1000h96v-1000h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    d: "M230 397v168q0 47 -17 64q-17 16 -71 16h-8v84h47q71 0 103 -24q44 -33 44 -115v-191q0 -73 56 -83v-80q-56 -10 -56 -83v-191q0 -82 -44 -115q-32 -24 -103 -24h-47v84h8q54 0 71 16q17 17 17 64v168q0 49 12 74q16 32 50 47q-34 15 -50 47q-12 25 -12 74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    d: "M435 361l57 -33q-26 -62 -66 -93q-36 -28 -83 -28q-36 0 -112 32q-61 26 -87 26q-31 0 -51 -22q-18 -18 -29 -45l-56 36q21 51 50 83q37 42 92 42q38 0 110 -31q65 -28 93 -28q29 0 49 18q20 17 33 43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10023",
    unicode: "\u0401",
    d: "M448 667v-96h-266v-169h258v-96h-258v-210h266v-96h-368v667h368zM104 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM300 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10051",
    unicode: "\u0402",
    horizAdvX: 668,
    d: "M486 571h-220v-186q71 23 137 23q80 0 130 -30q87 -51 87 -179q0 -116 -73 -168q-51 -37 -140 -37q-27 0 -67 6v94q27 -6 64 -6q51 0 78 21q34 28 34 89q0 71 -53 100q-31 16 -77 16q-68 0 -120 -23v-291h-102v571h-154v96h476v-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10052",
    unicode: "\u0403",
    horizAdvX: 428,
    d: "M80 0v667h334v-96h-232v-571h-102zM234 727l-48 40l138 139l86 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10053",
    unicode: "\u0404",
    horizAdvX: 620,
    d: "M574 631v-120q-81 74 -181 74q-115 0 -178 -70q-47 -51 -59 -125h328v-96h-331q7 -81 61 -139q67 -74 180 -74q99 0 180 77v-121q-84 -50 -183 -50q-139 0 -236 92q-107 100 -107 252q0 160 107 261q92 87 241 87q103 0 178 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10054",
    unicode: "\u0405",
    horizAdvX: 516,
    d: "M450 567l-82 -48q-10 24 -30 42q-30 24 -72 24q-45 0 -69.5 -23t-24.5 -57q0 -52 72 -81l67 -27q157 -64 157 -196q0 -95 -60.5 -154.5t-154.5 -59.5q-97 0 -157 67q-49 55 -56 130l101 22q0 -48 28 -85q32 -40 87 -40q47 0 78.5 31t31.5 81q0 46 -26.5 71t-69.5 43 l-64 27q-136 57 -136 169q0 72 52.5 124t142.5 52q81 0 134 -45q31 -28 51 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10055",
    unicode: "\u0406",
    horizAdvX: 262,
    d: "M80 667h102v-667h-102v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10056",
    unicode: "\u0407",
    horizAdvX: 262,
    d: "M80 667h102v-667h-102v667zM14 795q0 23 15 39.5t35 16.5t35.5 -17t15.5 -39t-15.5 -39t-35.5 -17t-35 16.5t-15 39.5zM148 795q0 23 15 39.5t35 16.5t35 -16.5t15 -39.5t-15 -39.5t-35 -16.5t-35 16.5t-15 39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10057",
    unicode: "\u0408",
    horizAdvX: 362,
    d: "M180 667h102v-432q0 -102 -25 -152q-48 -96 -157 -96q-66 0 -118 34l50 86q28 -24 70 -24q49 0 67 45q11 28 11 107v432z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10058",
    unicode: "\u0409",
    horizAdvX: 900,
    d: "M144 667h426v-269h76q107 0 167 -53q63 -55 63 -147q0 -48 -21.5 -91.5t-61.5 -70.5q-54 -36 -146 -36h-179v571h-222v-332q0 -48 -3 -77.5t-18.5 -66.5t-44.5 -61q-49 -40 -121 -40q-21 0 -45 6v94q20 -6 37 -6q37 0 60 23q16 15 23.5 45.5t8.5 50.5t1 62v398zM570 302 v-206h72q134 0 134 101q0 44 -29.5 74.5t-102.5 30.5h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10059",
    unicode: "\u040A",
    horizAdvX: 900,
    d: "M182 667v-264h286v264h102v-264h76q107 0 167 -53q63 -55 63 -147q0 -113 -83 -167q-54 -36 -146 -36h-179v307h-286v-307h-102v667h102zM570 307v-211h72q76 0 108 32q26 26 26 74t-28 74q-33 31 -104 31h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10060",
    unicode: "\u040B",
    horizAdvX: 690,
    d: "M486 571h-220v-178q62 7 129 7q118 0 170 -41q65 -51 65 -162v-197h-102v182q0 75 -36 103q-27 21 -106 21q-55 0 -120 -7v-299h-102v571h-154v96h476v-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10061",
    unicode: "\u040C",
    horizAdvX: 586,
    d: "M182 667v-266l258 266h134l-301 -302l303 -365h-136l-238 296l-20 -20v-276h-102v667h102zM277 727l-48 40l138 139l86 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10062",
    unicode: "\u040E",
    horizAdvX: 570,
    d: "M6 667h124l172 -356l156 356h106l-301 -667h-106l86 189zM129 832l80 36q6 -19 18.5 -31.5t28 -17t23.5 -6t15 -1.5t15 1.5t23.5 6t28 17t18.5 31.5l80 -36q-23 -56 -69.5 -79t-95.5 -23t-95.5 23t-69.5 79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10145",
    unicode: "\u040F",
    horizAdvX: 640,
    d: "M80 0v667h102v-571h276v571h102v-667h-192v-166h-96v166h-192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10017",
    unicode: "\u0410",
    horizAdvX: 656,
    d: "M542 0l-70 161h-285l-73 -161h-110l332 706l316 -706h-110zM229 257h202l-99 226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10018",
    unicode: "\u0411",
    horizAdvX: 526,
    d: "M80 0v667h334v-96h-232v-173h66q107 0 167 -53q63 -55 63 -147q0 -48 -21.5 -91.5t-61.5 -70.5q-54 -36 -146 -36h-169zM182 302v-206h62q134 0 134 101q0 44 -29.5 74.5t-102.5 30.5h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10019",
    unicode: "\u0412",
    horizAdvX: 526,
    d: "M80 667h101q68 0 110 -11t74 -41q53 -50 53 -132q0 -47 -20 -79q-18 -31 -50 -46q52 -13 86 -48q44 -46 44 -125q0 -73 -44 -120q-62 -65 -187 -65h-167v667zM182 571v-191h31q56 0 83 26q26 25 26 76q0 41 -24 64q-26 25 -81 25h-35zM182 296v-200h62q69 0 101 26 q33 26 33 74q0 43 -27 70q-31 30 -105 30h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10020",
    unicode: "\u0413",
    horizAdvX: 428,
    d: "M80 0v667h334v-96h-232v-571h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10021",
    unicode: "\u0414",
    horizAdvX: 650,
    d: "M144 667h416v-571h76v-246h-96v150h-430v-150h-96v246q34 -1 62 24.5t44 65.5q24 61 24 175v306zM246 571v-210q0 -125 -23 -186q-18 -46 -52 -79h287v475h-212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10022",
    unicode: "\u0415",
    d: "M448 667v-96h-266v-169h258v-96h-258v-210h266v-96h-368v667h368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10024",
    unicode: "\u0416",
    horizAdvX: 846,
    d: "M372 667h102v-269l238 269h124l-275 -306l281 -361h-126l-226 294l-16 -18v-276h-102v276l-16 18l-226 -294h-126l281 361l-275 306h124l238 -269v269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10025",
    unicode: "\u0417",
    horizAdvX: 570,
    d: "M137 516l-67 65q37 49 86 72q50 25 121 25q100 0 155 -53q48 -47 48 -117q0 -48 -22 -83q-21 -36 -60 -58q55 -14 90 -59q34 -43 34 -113q0 -90 -67 -149q-68 -58 -180 -58q-95 0 -164 52q-54 42 -85 108l90 46q20 -51 62 -81q44 -31 110 -31t102 36q32 32 32 82 q0 52 -39 78q-37 26 -121 26h-60v96h54q64 0 96 27q30 25 30 68q0 45 -32 69q-26 20 -77 20q-48 0 -81 -19q-32 -18 -55 -49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10026",
    unicode: "\u0418",
    horizAdvX: 712,
    d: "M530 0v449l-450 -479v697h102v-451l450 479v-695h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10027",
    unicode: "\u0419",
    horizAdvX: 712,
    d: "M530 0v449l-450 -479v697h102v-451l450 479v-695h-102zM191 832l80 36q6 -19 18.5 -31.5t28 -17t23.5 -6t15 -1.5t15 1.5t23.5 6t28 17t18.5 31.5l80 -36q-23 -56 -69.5 -79t-95.5 -23t-95.5 23t-69.5 79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10028",
    unicode: "\u041A",
    horizAdvX: 586,
    d: "M182 667v-266l258 266h134l-301 -302l303 -365h-136l-238 296l-20 -20v-276h-102v667h102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10029",
    unicode: "\u041B",
    horizAdvX: 650,
    d: "M144 667h426v-667h-102v571h-222v-332q0 -48 -3 -77.5t-18.5 -66.5t-44.5 -61q-49 -40 -121 -40q-21 0 -45 6v94q20 -6 37 -6q37 0 60 23q16 15 23.5 45.5t8.5 50.5t1 62v398z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10030",
    unicode: "\u041C",
    horizAdvX: 852,
    d: "M164 0h-104l140 717l232 -518l234 518l126 -717h-104l-68 402l-194 -433l-192 434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10031",
    unicode: "\u041D",
    horizAdvX: 650,
    d: "M182 667v-264h286v264h102v-667h-102v307h-286v-307h-102v667h102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10032",
    unicode: "\u041E",
    horizAdvX: 790,
    d: "M395 679q149 0 248 -99t99 -247t-99 -247t-248 -99t-248 99t-99 247t99 247t248 99zM395 81q107 0 176 70.5t69 181.5t-69 181.5t-176 70.5t-176 -70.5t-69 -181.5t69 -181.5t176 -70.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10033",
    unicode: "\u041F",
    horizAdvX: 650,
    d: "M80 667h490v-667h-102v571h-286v-571h-102v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10034",
    unicode: "\u0420",
    horizAdvX: 480,
    d: "M80 667h147q92 0 146 -36q40 -27 61.5 -70.5t21.5 -91.5q0 -90 -65 -146q-61 -52 -163 -52h-46v-271h-102v667zM182 573v-208h46q64 0 97 28.5t33 76.5q0 17 -4.5 32t-17 32.5t-40.5 28t-69 10.5h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10035",
    unicode: "\u0421",
    horizAdvX: 620,
    d: "M574 631v-120q-82 74 -181 74q-108 0 -175.5 -71.5t-67.5 -182.5q0 -107 69 -178.5t175 -71.5q99 0 180 77v-121q-84 -50 -183 -50q-139 0 -236 92q-107 100 -107 252q0 160 107 261q92 87 241 87q103 0 178 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10036",
    unicode: "\u0422",
    horizAdvX: 428,
    d: "M418 571h-153v-571h-102v571h-153v96h408v-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10037",
    unicode: "\u0423",
    horizAdvX: 570,
    d: "M6 667h124l172 -356l156 356h106l-301 -667h-106l86 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10038",
    unicode: "\u0424",
    horizAdvX: 826,
    d: "M362 0v94h-18q-148 0 -222 72.5t-74 187.5t74 187.5t222 72.5h18v80h102v-80h18q148 0 222 -72.5t74 -187.5t-74 -187.5t-222 -72.5h-18v-94h-102zM362 188v332h-20q-96 0 -144 -45.5t-48 -120.5t48 -120.5t144 -45.5h20zM464 520v-332h20q96 0 144 45.5t48 120.5 t-48 120.5t-144 45.5h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10039",
    unicode: "\u0425",
    horizAdvX: 546,
    d: "M10 0l210 348l-184 319h114l130 -226l133 226h114l-192 -319l201 -348h-114l-146 255l-152 -255h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10040",
    unicode: "\u0426",
    horizAdvX: 660,
    d: "M80 0v667h102v-571h276v571h102v-571h86v-246h-96v150h-470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10041",
    unicode: "\u0427",
    horizAdvX: 606,
    d: "M424 0v274q-91 -7 -136 -7q-111 0 -163 41q-65 51 -65 162v197h102v-182q0 -75 36 -103q27 -21 106 -21q57 0 120 7v299h102v-667h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10042",
    unicode: "\u0428",
    horizAdvX: 938,
    d: "M80 0v667h102v-571h236v571h102v-571h236v571h102v-667h-778z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10043",
    unicode: "\u0429",
    horizAdvX: 958,
    d: "M80 0v667h102v-571h236v571h102v-571h236v571h102v-571h86v-246h-96v150h-768z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10044",
    unicode: "\u042A",
    horizAdvX: 592,
    d: "M160 0v571h-150v96h252v-269h76q107 0 167 -53q63 -55 63 -147q0 -48 -21.5 -91.5t-61.5 -70.5q-54 -36 -146 -36h-179zM262 302v-206h72q134 0 134 101q0 44 -29.5 74.5t-102.5 30.5h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10045",
    unicode: "\u042B",
    horizAdvX: 740,
    d: "M80 0v667h102v-269h76q107 0 167 -53q63 -55 63 -147q0 -48 -21.5 -91.5t-61.5 -70.5q-54 -36 -146 -36h-179zM182 302v-206h72q134 0 134 101q0 44 -29.5 74.5t-102.5 30.5h-74zM558 667h102v-667h-102v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10046",
    unicode: "\u042C",
    horizAdvX: 512,
    d: "M80 0v667h102v-269h76q107 0 167 -53q63 -55 63 -147q0 -48 -21.5 -91.5t-61.5 -70.5q-54 -36 -146 -36h-179zM182 302v-206h72q134 0 134 101q0 44 -29.5 74.5t-102.5 30.5h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10047",
    unicode: "\u042D",
    horizAdvX: 622,
    d: "M48 511v120q84 48 193 48q146 0 234 -87q99 -98 99 -258q0 -157 -99 -256q-91 -91 -237 -91q-106 0 -190 50v121q76 -77 190 -77q102 0 162 60t68 149h-330v96h328q-9 81 -61 135q-62 64 -166 64q-108 0 -191 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10048",
    unicode: "\u042E",
    horizAdvX: 1000,
    d: "M182 402h100q17 104 89 178q97 99 244 99q146 0 241.5 -99t95.5 -247t-96 -247t-241 -99q-166 0 -261 117q-69 86 -72 202h-100v-306h-102v667h102v-265zM615 81q103 0 169 71t66 181t-66 181t-169 71t-169 -71t-66 -181t66 -181t169 -71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10049",
    unicode: "\u042F",
    horizAdvX: 534,
    d: "M20 0l198 278q-59 7 -103 45q-57 50 -57 142q0 84 51 139q27 29 64 44t60 17t57 2h164v-667h-102v267h-24l-182 -267h-126zM352 573h-50q-82 0 -114 -31q-32 -30 -32 -77q0 -54 38 -80q36 -24 102 -24h56v212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10065",
    unicode: "\u0430",
    horizAdvX: 530,
    d: "M370 372v49h98v-421h-98v44q-49 -57 -126 -57q-93 0 -148.5 66t-55.5 158q0 100 59.5 160.5t145.5 60.5q79 0 125 -60zM257 344q-52 0 -84.5 -39t-32.5 -96q0 -56 32.5 -95t84.5 -39q50 0 84.5 35t34.5 98q0 65 -34.5 100.5t-84.5 35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10066",
    unicode: "\u0431",
    horizAdvX: 530,
    d: "M380 710h100q-11 -52 -46 -90t-86 -52l-66 -18q-26 -7 -40 -12t-34.5 -18.5t-34.5 -32.5q-33 -44 -35 -114h1q44 59 143 59q89 0 147 -60q61 -63 61 -160q0 -98 -64.5 -161.5t-160.5 -63.5t-154 56q-32 30 -49 74t-19.5 72.5t-2.5 69.5q0 196 64 289q48 71 126 90l70 17 q69 17 80 55zM265 75q57 0 91 36.5t34 97.5q0 67 -36.5 101t-88.5 34t-88.5 -34t-36.5 -101q0 -61 34 -97.5t91 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10067",
    unicode: "\u0432",
    horizAdvX: 442,
    d: "M62 421h165q63 0 96 -25q39 -31 39 -81q0 -57 -50 -82q32 -6 57 -28q33 -30 33 -81q0 -61 -46 -96q-38 -28 -97 -28h-197v421zM160 257h50q26 0 39 9q19 12 19 34q0 21 -17 33q-12 8 -43 8h-48v-84zM160 80h73q33 0 51 12q20 13 20 37q0 26 -19 37q-17 11 -49 11h-76v-97 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10068",
    unicode: "\u0433",
    horizAdvX: 328,
    d: "M62 0v421h258v-90h-160v-331h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10069",
    unicode: "\u0434",
    horizAdvX: 486,
    d: "M98 421h316v-331h64v-210h-90v120h-294v-120h-90v210q51 3 77 55q17 37 17 111v165zM316 90v241h-124v-112q0 -91 -49 -129h173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10070",
    unicode: "\u0435",
    horizAdvX: 482,
    d: "M357 142l82 -46q-28 -50 -71 -77q-49 -32 -124 -32q-88 0 -142 54q-62 62 -62 161q0 104 67 173q57 57 141 57q82 0 135 -55q59 -61 59 -178v-12h-302q4 -53 36 -85q27 -27 75 -27q39 0 67 21q23 18 39 46zM147 267h195q-6 35 -30 57q-26 24 -66 24q-42 0 -69 -27 q-22 -20 -30 -54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10072",
    unicode: "\u0436",
    horizAdvX: 624,
    d: "M263 421h98v-156l127 156h118l-163 -192l179 -229h-122l-127 169l-12 -14v-155h-98v155l-12 14l-127 -169h-122l179 229l-163 192h118l127 -156v156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10073",
    unicode: "\u0437",
    horizAdvX: 440,
    d: "M119 312l-63 55q24 29 64 47q42 18 99 18q66 0 107 -29q44 -32 44 -86q0 -35 -18 -58q-15 -20 -40 -30q38 -8 61 -31q27 -27 27 -70q0 -57 -36 -93q-48 -48 -148 -48q-67 0 -110 25q-45 26 -66 75l78 40q14 -30 37 -44q25 -16 63 -16q46 0 67 21q15 17 15 37q0 21 -13 34 q-17 18 -70 18h-44v80h37q32 0 48 11q18 14 18 37q0 24 -18 36q-15 11 -47 11q-30 0 -55 -12q-21 -10 -37 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10074",
    unicode: "\u0438",
    horizAdvX: 510,
    d: "M62 421h98v-239l288 277v-459h-98v245l-288 -277v453z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10075",
    unicode: "\u0439",
    horizAdvX: 510,
    d: "M62 421h98v-239l288 277v-459h-98v245l-288 -277v453zM94 603l80 23q19 -65 82 -65q62 0 82 65l80 -23q-16 -57 -64.5 -87.5t-97.5 -30.5t-97.5 30.5t-64.5 87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10076",
    unicode: "\u043A",
    horizAdvX: 442,
    d: "M62 421h98v-150l140 150h130l-184 -184l194 -237h-124l-140 173l-16 -16v-157h-98v421z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10077",
    unicode: "\u043B",
    horizAdvX: 470,
    d: "M408 421v-421h-98v331h-124v-167q0 -78 -40 -121q-51 -57 -138 -43v90q43 -10 69 19q15 18 15 55v257h316z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10078",
    unicode: "\u043C",
    horizAdvX: 580,
    d: "M14 0l102 459l174 -321l174 321l102 -459h-100l-42 211l-134 -243l-134 243l-42 -211h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10079",
    unicode: "\u043D",
    horizAdvX: 494,
    d: "M62 0v421h98v-156h174v156h98v-421h-98v175h-174v-175h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10080",
    unicode: "\u043E",
    horizAdvX: 530,
    d: "M265 432q96 0 160.5 -62.5t64.5 -159.5q0 -96 -64.5 -159.5t-160.5 -63.5t-160.5 63.5t-64.5 159.5q0 97 64.5 159.5t160.5 62.5zM265 75q57 0 91 36.5t34 97.5q0 67 -36.5 101t-88.5 34t-88.5 -34t-36.5 -101q0 -61 34 -97.5t91 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10081",
    unicode: "\u043F",
    horizAdvX: 490,
    d: "M62 421h366v-421h-98v331h-170v-331h-98v421z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10082",
    unicode: "\u0440",
    horizAdvX: 530,
    d: "M160 49v-278h-98v650h98v-46q48 57 125 57q86 0 145.5 -60.5t59.5 -158.5q0 -101 -62 -163.5t-142 -62.5q-75 0 -126 62zM273 344q-50 0 -84.5 -35.5t-34.5 -100.5q0 -63 34.5 -98t84.5 -35q52 0 84.5 39t32.5 95q0 57 -32.5 96t-84.5 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10083",
    unicode: "\u0441",
    horizAdvX: 420,
    d: "M388 402v-110q-53 52 -119 52q-56 0 -93 -37q-36 -36 -36 -97q0 -63 38 -101q36 -34 89 -34q73 0 121 54v-109q-53 -33 -128 -33q-101 0 -160 62q-60 62 -60 158q0 99 64 163q62 62 169 62q61 0 115 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10084",
    unicode: "\u0442",
    horizAdvX: 360,
    d: "M352 331h-123v-331h-98v331h-123v90h344v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10085",
    unicode: "\u0443",
    horizAdvX: 482,
    d: "M31 -229l155 295l-180 355h118l120 -246l122 246h110l-335 -650h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10086",
    unicode: "\u0444",
    horizAdvX: 670,
    d: "M286 -229v222q-108 -1 -173 55q-71 60 -71 163q0 102 70 162q64 55 174 55v239h98v-239q110 0 174 -55q70 -60 70 -162q0 -103 -71 -163q-65 -56 -173 -55v-222h-98zM286 81v259q-58 0 -92 -22q-52 -31 -52 -107q0 -71 49 -105q38 -27 95 -25zM384 340v-259q57 -2 95 25 q49 34 49 105q0 76 -52 107q-34 22 -92 22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10087",
    unicode: "\u0445",
    horizAdvX: 496,
    d: "M6 0l186 228l-150 193h116l93 -123l94 123h120l-155 -193l180 -228h-118l-121 157l-125 -157h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10088",
    unicode: "\u0446",
    horizAdvX: 502,
    d: "M62 0v421h98v-331h166v331h98v-331h70v-210h-90v120h-342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10089",
    unicode: "\u0447",
    horizAdvX: 450,
    d: "M290 0v163q-45 -9 -86 -9q-72 0 -111 31q-41 33 -41 101v135h98v-115q0 -43 25 -58q17 -10 49 -10q36 0 66 11v172h98v-421h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10090",
    unicode: "\u0448",
    horizAdvX: 698,
    d: "M62 0v421h98v-331h140v331h98v-331h140v331h98v-421h-574z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10091",
    unicode: "\u0449",
    horizAdvX: 714,
    d: "M62 0v421h98v-331h140v331h98v-331h140v331h98v-331h70v-210h-90v120h-554z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10092",
    unicode: "\u044A",
    horizAdvX: 436,
    d: "M98 0v331h-90v90h188v-149h56q27 0 44 -1.5t41 -11.5t42 -30q33 -37 33 -92q0 -63 -38 -101q-17 -17 -40.5 -25.5t-39 -9.5t-43.5 -1h-153zM196 84h45q36 0 51 9q22 16 22 43q0 28 -21 42q-16 10 -51 10h-46v-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10093",
    unicode: "\u044B",
    horizAdvX: 580,
    d: "M62 0v421h98v-149h56q27 0 44 -1.5t41 -11.5t42 -30q33 -37 33 -92q0 -63 -38 -101q-17 -17 -40.5 -25.5t-39 -9.5t-43.5 -1h-153zM160 84h45q36 0 51 9q22 16 22 43q0 28 -21 42q-16 10 -51 10h-46v-104zM420 0v421h98v-421h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10094",
    unicode: "\u044C",
    horizAdvX: 400,
    d: "M62 0v421h98v-149h56q27 0 44 -1.5t41 -11.5t42 -30q33 -37 33 -92q0 -63 -38 -101q-17 -17 -40.5 -25.5t-39 -9.5t-43.5 -1h-153zM160 84h45q36 0 51 9q22 16 22 43q0 28 -21 42q-16 10 -51 10h-46v-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10095",
    unicode: "\u044D",
    horizAdvX: 428,
    d: "M40 317v93q56 22 119 22q106 0 168 -62q61 -61 61 -159t-62 -161q-60 -63 -157 -63q-68 0 -129 24v93q51 -29 115 -29q61 0 95 34q25 25 31 65h-195v82h192q-8 45 -42 67q-30 21 -81 21q-60 0 -115 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10096",
    unicode: "\u044E",
    horizAdvX: 700,
    d: "M160 265h67q10 59 55 105q62 62 157 62q94 0 157.5 -62.5t63.5 -159.5q0 -96 -63.5 -159.5t-157.5 -63.5q-100 0 -162 67q-46 50 -52 121h-65v-175h-98v421h98v-156zM439 344q-51 0 -86 -34t-35 -101t35 -100.5t86 -33.5t86 33.5t35 100.5t-35 101t-86 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10097",
    unicode: "\u044F",
    horizAdvX: 418,
    d: "M8 0l132 167q-39 6 -67 32q-35 34 -35 87q0 60 39 97q40 38 122 38h157v-421h-98v155h-20l-115 -155h-115zM258 235v102h-57q-35 0 -51 -9q-24 -15 -24 -42t20 -41q15 -10 54 -10h58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10071",
    unicode: "\u0451",
    horizAdvX: 482,
    d: "M357 142l82 -46q-28 -50 -71 -77q-49 -32 -124 -32q-88 0 -142 54q-62 62 -62 161q0 104 67 173q57 57 141 57q82 0 135 -55q59 -61 59 -178v-12h-302q4 -53 36 -85q27 -27 75 -27q39 0 67 21q23 18 39 46zM147 267h195q-6 35 -30 57q-26 24 -66 24q-42 0 -69 -27 q-22 -20 -30 -54zM102 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM282 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10099",
    unicode: "\u0452",
    horizAdvX: 486,
    d: "M62 0v512h-72v76h72v141h98v-141h200v-76h-200v-167q46 47 113 47q84 0 124 -57q27 -39 27 -117v-304q0 -83 -44 -117q-34 -27 -90 -27q-42 0 -66 9v88q22 -9 47 -9q33 0 46 22q9 15 9 60v269q0 52 -19 73q-20 22 -55 22q-48 0 -72 -35q-20 -29 -20 -106v-163h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10100",
    unicode: "\u0453",
    horizAdvX: 328,
    d: "M62 0v421h258v-90h-160v-331h-98zM265 675l90 -46l-156 -144l-54 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10101",
    unicode: "\u0454",
    horizAdvX: 428,
    d: "M388 404v-104q-47 44 -117 44q-50 0 -82 -27q-27 -22 -39 -60h192v-80h-195q4 -44 35 -71q36 -31 91 -31q66 0 115 46v-104q-46 -30 -128 -30q-97 0 -160 64q-60 61 -60 159q0 102 68 165q61 57 161 57q67 0 119 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10102",
    unicode: "\u0455",
    horizAdvX: 360,
    d: "M319 358l-73 -48q-22 36 -60 36q-19 0 -30 -11q-9 -9 -9 -22q0 -15 14 -24q3 -2 6 -3.5l11 -5.5l16 -8l50 -25q42 -21 59 -39q31 -31 31 -78q0 -56 -37 -96q-43 -47 -118 -47q-56 0 -91 27q-38 28 -54 77l80 38q10 -29 23 -40q16 -16 43 -16q26 0 40 14t14 33 q0 18 -13 32q-14 14 -42 26l-36 17q-42 20 -58 36q-30 29 -30 71q0 53 35 90q38 40 103 40q45 0 78 -22q30 -19 48 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10103",
    unicode: "\u0456",
    horizAdvX: 222,
    d: "M62 421h98v-421h-98v421zM48 595q0 27 18 45t45 18t45 -18t18 -45t-18 -45t-45 -18t-45 18t-18 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10104",
    unicode: "\u0457",
    horizAdvX: 232,
    d: "M67 421h98v-421h-98v421zM176 658q19 0 34 -16.5t15 -45.5t-15 -45.5t-34 -16.5t-34 16.5t-15 45.5t15 45.5t34 16.5zM56 658q19 0 34 -16.5t15 -45.5t-15 -45.5t-34 -16.5t-34 16.5t-15 45.5t15 45.5t34 16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10105",
    unicode: "\u0458",
    horizAdvX: 222,
    d: "M62 421h98v-650h-98v650zM48 595q0 27 18 45t45 18t45 -18t18 -45t-18 -45t-45 -18t-45 18t-18 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10106",
    unicode: "\u0459",
    horizAdvX: 648,
    d: "M408 421v-149h56q27 0 44 -1.5t41 -11.5t42 -30q33 -37 33 -92q0 -63 -38 -101q-17 -17 -40.5 -25.5t-39 -9.5t-43.5 -1h-153v331h-124v-167q0 -78 -40 -121q-42 -45 -113 -45q-9 0 -25 2v90q12 -2 19 -2q33 0 50 21q15 18 15 55v257h316zM408 84h45q36 0 51 9 q22 16 22 43q0 28 -21 42q-16 10 -51 10h-46v-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10107",
    unicode: "\u045A",
    horizAdvX: 672,
    d: "M62 0v421h98v-149h174v149h98v-149h56q27 0 44 -1.5t41 -11.5t42 -30q33 -37 33 -92q0 -63 -38 -101q-17 -17 -40.5 -25.5t-39 -9.5t-43.5 -1h-153v188h-174v-188h-98zM432 84h45q36 0 51 9q22 16 22 43q0 28 -21 42q-16 10 -51 10h-46v-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10108",
    unicode: "\u045B",
    horizAdvX: 486,
    d: "M62 0v512h-72v76h72v141h98v-141h200v-76h-200v-167q46 47 113 47q84 0 124 -57q27 -39 27 -117v-218h-98v209q0 52 -19 73q-20 22 -55 22q-48 0 -72 -35q-20 -29 -20 -106v-163h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10109",
    unicode: "\u045C",
    horizAdvX: 442,
    d: "M62 421h98v-150l140 150h130l-184 -184l194 -237h-124l-140 173l-16 -16v-157h-98v421zM296 675l90 -46l-156 -144l-54 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10110",
    unicode: "\u045E",
    horizAdvX: 482,
    d: "M31 -229l155 295l-180 355h118l120 -246l122 246h110l-335 -650h-110zM83 603l80 23q19 -65 82 -65q62 0 82 65l80 -23q-16 -57 -64.5 -87.5t-97.5 -30.5t-97.5 30.5t-64.5 87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10193",
    unicode: "\u045F",
    horizAdvX: 486,
    d: "M62 0v421h98v-331h166v331h98v-421h-136v-130h-90v130h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10146",
    unicode: "\u0462",
    horizAdvX: 592,
    d: "M160 0v503h-150v94h150v97h102v-97h180v-94h-180v-105h76q107 0 167 -53q63 -56 63 -146q0 -49 -21 -92.5t-62 -70.5q-54 -36 -146 -36h-179zM262 302v-206h72q75 0 108 33q26 26 26 68q0 46 -28 73q-33 32 -104 32h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10194",
    unicode: "\u0463",
    horizAdvX: 436,
    d: "M8 421h90v246h98v-246h120v-84h-120v-65h56q27 0 44 -1.5t41 -11.5t42 -30q33 -37 33 -92q0 -63 -38 -101q-17 -17 -40.5 -25.5t-39 -9.5t-43.5 -1h-153v337h-90v84zM196 84h45q36 0 51 9q22 16 22 43q0 28 -21 42q-16 10 -51 10h-46v-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10147",
    unicode: "\u0472",
    horizAdvX: 790,
    d: "M395 679q149 0 248 -99t99 -247t-99 -247t-248 -99t-248 99t-99 247t99 247t248 99zM637 287h-484q12 -88 78.5 -147t163.5 -59t163.5 59t78.5 147zM153 383h484q-12 85 -78.5 143.5t-163.5 58.5t-163.5 -58.5t-78.5 -143.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10195",
    unicode: "\u0473",
    horizAdvX: 530,
    d: "M265 432q96 0 160.5 -62.5t64.5 -159.5q0 -96 -64.5 -159.5t-160.5 -63.5t-160.5 63.5t-64.5 159.5q0 97 64.5 159.5t160.5 62.5zM386 173h-242q8 -47 41.5 -72.5t79.5 -25.5t79.5 25.5t41.5 72.5zM144 253h242q-9 41 -40.5 66t-80.5 25t-80.5 -25t-40.5 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10148",
    unicode: "\u0474",
    horizAdvX: 600,
    d: "M4 667h110l186 -465l186 465h110l-296 -710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10196",
    unicode: "\u0475",
    horizAdvX: 448,
    d: "M6 421h110l108 -240l108 240h110l-218 -451z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10050",
    unicode: "\u0490",
    horizAdvX: 428,
    d: "M80 0v667h238v150h96v-246h-232v-571h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10098",
    unicode: "\u0491",
    horizAdvX: 328,
    d: "M62 0v421h168v120h90v-210h-160v-331h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0492",
    unicode: "\u0492",
    horizAdvX: 428,
    d: "M80 0v322h-90v86h90v259h334v-96h-232v-163h150v-86h-150v-322h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0493",
    unicode: "\u0493",
    horizAdvX: 328,
    d: "M62 0v168h-72v80h72v173h258v-90h-160v-83h100v-80h-100v-168h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0494",
    unicode: "\u0494",
    horizAdvX: 584,
    d: "M402 571h-220v-186q71 23 137 23q80 0 130 -30q87 -51 87 -179q0 -116 -73 -168q-51 -37 -140 -37q-27 0 -67 6v94q27 -6 64 -6q51 0 78 21q34 28 34 89q0 71 -53 100q-31 16 -77 16q-68 0 -120 -23v-291h-102v667h322v-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0495",
    unicode: "\u0495",
    horizAdvX: 440,
    d: "M62 0v421h258v-90h-160v-95h30q98 0 153 -52q57 -53 57 -147q0 -109 -77 -180q-60 -55 -143 -65v90q47 7 78 41q42 44 42 113q0 57 -33 86q-29 26 -86 26h-21v-148h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0496",
    unicode: "\u0496",
    horizAdvX: 856,
    d: "M372 667h102v-269l238 269h124l-275 -306l206 -265h75v-246h-96v150h-30l-226 294l-16 -18v-276h-102v276l-16 18l-226 -294h-126l281 361l-275 306h124l238 -269v269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0497",
    unicode: "\u0497",
    horizAdvX: 630,
    d: "M263 421h98v-156l127 156h118l-163 -192l109 -139h70v-210h-90v120h-32l-127 169l-12 -14v-155h-98v155l-12 14l-127 -169h-122l179 229l-163 192h118l127 -156v156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0498",
    unicode: "\u0498",
    horizAdvX: 570,
    d: "M137 516l-67 65q37 49 86 72q50 25 121 25q100 0 155 -53q48 -47 48 -117q0 -48 -22 -83q-21 -36 -60 -58q55 -14 90 -59q34 -43 34 -113q0 -90 -67 -149q-48 -42 -112 -52v-160h-96v156q-76 5 -136 50q-55 41 -85 108l90 46q20 -51 62 -81q44 -31 110 -31t102 36 q32 32 32 82q0 52 -39 78q-37 26 -121 26h-60v96h54q64 0 96 27q30 25 30 68q0 45 -32 69q-26 20 -77 20q-48 0 -81 -19q-32 -18 -55 -49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0499",
    unicode: "\u0499",
    horizAdvX: 440,
    d: "M119 312l-63 55q24 29 64 47q42 18 99 18q66 0 107 -29q44 -32 44 -86q0 -35 -18 -58q-15 -20 -40 -30q38 -8 61 -31q27 -27 27 -70q0 -57 -36 -93t-88 -42v-123h-90v121q-50 1 -91 29q-37 25 -55 67l78 40q14 -30 37 -44q25 -16 63 -16q46 0 67 21q15 17 15 37 q0 21 -13 34q-17 18 -70 18h-44v80h37q32 0 48 11q18 14 18 37q0 24 -18 36q-15 11 -47 11q-30 0 -55 -12q-21 -10 -37 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049A",
    unicode: "\u049A",
    horizAdvX: 590,
    d: "M80 667h102v-266l258 266h134l-301 -302l223 -269h80v-246h-96v150h-40l-238 296l-20 -20v-276h-102v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049B",
    unicode: "\u049B",
    horizAdvX: 448,
    d: "M62 421h98v-150l140 150h130l-184 -184l121 -147h73v-210h-90v120h-34l-140 173l-16 -16v-157h-98v421z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049C",
    unicode: "\u049C",
    horizAdvX: 680,
    d: "M80 667h102v-264h86v140h90v-140l192 264h120l-227 -302l227 -365h-120l-192 313v-150h-90v150h-86v-313h-102v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049D",
    unicode: "\u049D",
    horizAdvX: 526,
    d: "M62 421h98v-152h60v100h80v-106l114 158h110l-138 -186l138 -235h-110l-114 195v-116h-80v110h-60v-189h-98v421z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A0",
    unicode: "\u04A0",
    horizAdvX: 700,
    d: "M194 0v571h-184v96h286v-266l258 266h134l-301 -302l303 -365h-136l-238 296l-20 -20v-276h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A1",
    unicode: "\u04A1",
    horizAdvX: 510,
    d: "M130 0v331h-122v90h220v-150l140 150h130l-184 -184l194 -237h-124l-140 173l-16 -16v-157h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A2",
    unicode: "\u04A2",
    horizAdvX: 670,
    d: "M80 0v667h102v-264h286v264h102v-571h86v-246h-96v150h-92v307h-286v-307h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A3",
    unicode: "\u04A3",
    horizAdvX: 510,
    d: "M62 0v421h98v-156h174v156h98v-331h70v-210h-90v120h-78v175h-174v-175h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A4",
    unicode: "\u04A4",
    horizAdvX: 816,
    d: "M80 0v667h102v-264h286v264h334v-96h-232v-571h-102v307h-286v-307h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A5",
    unicode: "\u04A5",
    horizAdvX: 600,
    d: "M62 0v421h98v-156h174v156h258v-90h-160v-331h-98v175h-174v-175h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AA",
    unicode: "\u04AA",
    horizAdvX: 620,
    d: "M574 631v-120q-76 74 -181 74q-102 0 -166 -61q-36 -35 -56.5 -86.5t-20.5 -106.5q0 -107 67 -177q69 -73 177 -73q100 0 180 77v-121q-62 -37 -131 -46v-157h-96v159q-109 9 -192 86q-107 99 -107 252q0 160 107 261q92 87 240 87q103 0 179 -48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AB",
    unicode: "\u04AB",
    horizAdvX: 420,
    d: "M388 402v-110q-53 52 -119 52q-56 0 -93 -37q-36 -36 -36 -97q0 -63 38 -101q36 -34 89 -34q73 0 121 54v-109q-38 -25 -79 -28v-122h-90v120q-68 7 -119 59q-60 62 -60 158q0 99 64 163q62 62 169 62q61 0 115 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AE",
    unicode: "\u04AE",
    horizAdvX: 540,
    d: "M219 0v288l-219 379h116l154 -267l154 267h116l-219 -379v-288h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AF",
    unicode: "\u04AF",
    horizAdvX: 448,
    d: "M6 421h110l108 -237l108 237h110l-169 -350v-300h-98v300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B0",
    unicode: "\u04B0",
    horizAdvX: 540,
    d: "M219 0v202h-190v86h190l-219 379h116l154 -267l154 267h116l-219 -379h190v-86h-190v-202h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B1",
    unicode: "\u04B1",
    horizAdvX: 448,
    d: "M6 421h110l108 -237l108 237h110l-169 -350v-51h130v-86h-130v-163h-98v163h-130v86h130v51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B2",
    unicode: "\u04B2",
    horizAdvX: 570,
    d: "M10 0l210 348l-184 319h114l130 -226l133 226h114l-192 -319l145 -252h76v-246h-96v150h-38l-146 255l-152 -255h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B3",
    unicode: "\u04B3",
    horizAdvX: 498,
    d: "M6 0l186 228l-150 193h116l93 -123l94 123h120l-155 -193l109 -138h71v-210h-90v120h-28l-121 157l-125 -157h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B6",
    unicode: "\u04B6",
    horizAdvX: 626,
    d: "M424 0v274q-91 -7 -136 -7q-111 0 -163 41q-65 51 -65 162v197h102v-182q0 -75 36 -103q27 -21 106 -21q57 0 120 7v299h102v-571h86v-246h-96v150h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B7",
    unicode: "\u04B7",
    horizAdvX: 466,
    d: "M290 0v163q-45 -9 -86 -9q-72 0 -111 31q-41 33 -41 101v135h98v-115q0 -43 25 -58q17 -10 49 -10q36 0 66 11v172h98v-331h70v-210h-90v120h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B8",
    unicode: "\u04B8",
    horizAdvX: 640,
    d: "M458 0v274q-48 -6 -98 -6v-138h-90v138q-88 3 -139 40q-71 52 -71 162v197h102v-182q0 -74 41 -103q25 -18 67 -20v148h90v-148q50 0 98 6v299h102v-667h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B9",
    unicode: "\u04B9",
    horizAdvX: 530,
    d: "M370 0v161q-39 -7 -68 -8v-88h-80v88q-83 0 -124 30q-46 33 -46 103v135h98v-115q0 -44 32 -58q17 -7 40 -7v114h80v-114q33 0 68 8v172h98v-421h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04BA",
    unicode: "\u04BA",
    horizAdvX: 606,
    d: "M182 667v-264q62 7 129 7q118 0 170 -41q65 -51 65 -162v-207h-102v192q0 75 -36 103q-27 21 -106 21q-55 0 -120 -7v-309h-102v667h102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04BB",
    unicode: "\u04BB",
    horizAdvX: 486,
    d: "M62 0v729h98v-344q46 47 113 47q84 0 124 -57q27 -39 27 -117v-258h-98v249q0 52 -19 73q-20 22 -55 22q-48 0 -72 -35q-20 -29 -20 -106v-203h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C0",
    unicode: "\u04C0",
    horizAdvX: 262,
    d: "M80 667h102v-667h-102v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C1",
    unicode: "\u04C1",
    horizAdvX: 846,
    d: "M372 667h102v-269l238 269h124l-275 -306l281 -361h-126l-226 294l-16 -18v-276h-102v276l-16 18l-226 -294h-126l281 361l-275 306h124l238 -269v269zM256 832l80 36q6 -19 18.5 -31.5t28 -17t23.5 -6t15 -1.5t15 1.5t23.5 6t28 17t18.5 31.5l80 -36q-23 -56 -69.5 -79 t-95.5 -23t-95.5 23t-69.5 79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C2",
    unicode: "\u04C2",
    horizAdvX: 624,
    d: "M263 421h98v-156l127 156h118l-163 -192l179 -229h-122l-127 169l-12 -14v-155h-98v155l-12 14l-127 -169h-122l179 229l-163 192h118l127 -156v156zM148 603l80 23q19 -65 82 -65q62 0 82 65l80 -23q-16 -57 -64.5 -87.5t-97.5 -30.5t-97.5 30.5t-64.5 87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C3",
    unicode: "\u04C3",
    horizAdvX: 616,
    d: "M80 667h102v-274l258 274h134l-267 -268q51 0 103.5 -19.5t88.5 -55.5q69 -70 69 -208q0 -148 -63 -217q-54 -59 -158 -59q-55 0 -105 21l24 93q38 -20 79 -20q48 0 78 30q43 44 43 145t-51 154q-47 49 -145 49q-42 0 -88 -11v-301h-102v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C4",
    unicode: "\u04C4",
    horizAdvX: 440,
    d: "M62 421h98v-150l140 150h130l-190 -192q67 -7 111 -53q49 -53 49 -141q0 -109 -77 -178q-60 -54 -143 -65v90q47 7 78 41q42 44 42 113q0 51 -29 82q-29 30 -92 30h-19v-148h-98v421z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C7",
    unicode: "\u04C7",
    horizAdvX: 650,
    d: "M80 0v667h102v-264h286v264h102v-753q0 -82 -44 -117q-33 -27 -94 -27q-36 0 -66 9v92q23 -9 47 -9q33 0 46 22q9 15 9 60v363h-286v-307h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C8",
    unicode: "\u04C8",
    horizAdvX: 494,
    d: "M62 0v421h98v-156h174v156h98v-507q0 -83 -44 -117q-34 -27 -90 -27q-42 0 -66 9v88q22 -9 47 -9q33 0 46 22q9 15 9 60v235h-174v-175h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D0",
    unicode: "\u04D0",
    horizAdvX: 656,
    d: "M542 0l-70 161h-285l-73 -161h-110l332 706l316 -706h-110zM229 257h202l-99 226zM167 832l80 36q6 -19 18.5 -31.5t28 -17t23.5 -6t15 -1.5t15 1.5t23.5 6t28 17t18.5 31.5l80 -36q-23 -56 -69.5 -79t-95.5 -23t-95.5 23t-69.5 79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D1",
    unicode: "\u04D1",
    horizAdvX: 530,
    d: "M370 372v49h98v-421h-98v44q-49 -57 -126 -57q-93 0 -148.5 66t-55.5 158q0 100 59.5 160.5t145.5 60.5q79 0 125 -60zM257 344q-52 0 -84.5 -39t-32.5 -96q0 -56 32.5 -95t84.5 -39q50 0 84.5 35t34.5 98q0 65 -34.5 100.5t-84.5 35.5zM88 603l80 23q19 -65 82 -65 q62 0 82 65l80 -23q-16 -57 -64.5 -87.5t-97.5 -30.5t-97.5 30.5t-64.5 87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D2",
    unicode: "\u04D2",
    horizAdvX: 656,
    d: "M542 0l-70 161h-285l-73 -161h-110l332 706l316 -706h-110zM229 257h202l-99 226zM172 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM368 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D3",
    unicode: "\u04D3",
    horizAdvX: 530,
    d: "M370 372v49h98v-421h-98v44q-49 -57 -126 -57q-93 0 -148.5 66t-55.5 158q0 100 59.5 160.5t145.5 60.5q79 0 125 -60zM257 344q-52 0 -84.5 -39t-32.5 -96q0 -56 32.5 -95t84.5 -39q50 0 84.5 35t34.5 98q0 65 -34.5 100.5t-84.5 35.5zM98 569q0 26 18 44t44 18t44 -18 t18 -44t-18 -44t-44 -18t-44 18t-18 44zM278 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D4",
    unicode: "\u04D4",
    horizAdvX: 926,
    d: "M546 0l-70 159h-283l-73 -159h-110l320 667h295l42 -96h-265l70 -159h258l42 -96h-258l95 -220h265l42 -96h-370zM238 255h198l-95 217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D5",
    unicode: "\u04D5",
    horizAdvX: 756,
    d: "M99 328v91q57 13 119 13q53 0 87 -13q37 -14 63 -47q24 29 58 43q38 17 87 17q91 0 144 -55q59 -62 59 -178v-12h-302q4 -53 36 -85q27 -27 75 -27q39 0 67 21q23 18 39 46l82 -46q-28 -50 -71 -77q-50 -32 -126 -32q-51 0 -88 18q-37 17 -60 50q-29 -35 -68 -52 q-38 -16 -89 -16q-83 0 -129 45q-42 41 -42 96q0 60 40 98q46 45 128 45q59 0 108 -28q0 51 -28 76q-29 25 -86 25q-48 0 -103 -16zM220 187q-46 0 -69 -21q-17 -16 -17 -37q0 -22 20 -39q23 -19 66 -19q38 0 63 16q27 17 27 44q0 26 -31 43q-25 13 -59 13zM421 267h195 q-6 35 -30 57q-26 24 -66 24t-69 -27q-22 -22 -30 -54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D6",
    unicode: "\u04D6",
    d: "M448 667v-96h-266v-169h258v-96h-258v-210h266v-96h-368v667h368zM100 832l80 36q6 -19 18.5 -31.5t28 -17t23.5 -6t15 -1.5t15 1.5t23.5 6t28 17t18.5 31.5l80 -36q-23 -56 -69.5 -79t-95.5 -23t-95.5 23t-69.5 79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D7",
    unicode: "\u04D7",
    horizAdvX: 482,
    d: "M357 142l82 -46q-28 -50 -71 -77q-49 -32 -124 -32q-88 0 -142 54q-62 62 -62 161q0 104 67 173q57 57 141 57q82 0 135 -55q59 -61 59 -178v-12h-302q4 -53 36 -85q27 -27 75 -27q39 0 67 21q23 18 39 46zM147 267h195q-6 35 -30 57q-26 24 -66 24q-42 0 -69 -27 q-22 -20 -30 -54zM79 603l80 23q19 -65 82 -65q62 0 82 65l80 -23q-16 -57 -64.5 -87.5t-97.5 -30.5t-97.5 30.5t-64.5 87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D8",
    unicode: "\u04D8",
    horizAdvX: 748,
    d: "M149 478l-72 66q31 42 73 71q89 64 203 64q154 0 252 -102q95 -99 95 -244q0 -147 -102 -249q-97 -97 -239 -97q-160 0 -248 124q-63 89 -63 215v31h549q-7 102 -77.5 165t-166.5 63q-126 0 -204 -107zM589 263h-432q6 -64 44 -111q58 -71 159 -71q110 0 177 77 q38 44 52 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10846",
    unicode: "\u04D9",
    horizAdvX: 488,
    d: "M133 292l-89 30q24 51 73 80q50 30 117 30q93 0 149 -52q65 -61 65 -174q0 -104 -64 -166q-54 -53 -142 -53q-84 0 -135 50q-67 65 -67 180v25h306q-5 49 -35 76q-28 26 -78 26q-38 0 -63 -16q-19 -11 -37 -36zM339 162h-195q6 -45 30 -68q23 -23 66 -23q42 0 68 26 q27 27 31 65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DA",
    unicode: "\u04DA",
    horizAdvX: 748,
    d: "M149 478l-72 66q31 42 73 71q89 64 203 64q154 0 252 -102q95 -99 95 -244q0 -147 -102 -249q-97 -97 -239 -97q-160 0 -248 124q-63 89 -63 215v31h549q-7 102 -77.5 165t-166.5 63q-126 0 -204 -107zM589 263h-432q6 -64 44 -111q58 -71 159 -71q110 0 177 77 q38 44 52 105zM214 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM410 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DB",
    unicode: "\u04DB",
    horizAdvX: 488,
    d: "M133 292l-89 30q24 51 73 80q50 30 117 30q93 0 149 -52q65 -61 65 -174q0 -104 -64 -166q-54 -53 -142 -53q-84 0 -135 50q-67 65 -67 180v25h306q-5 49 -35 76q-28 26 -78 26q-38 0 -63 -16q-19 -11 -37 -36zM339 162h-195q6 -45 30 -68q23 -23 66 -23q42 0 68 26 q27 27 31 65zM92 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM272 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DC",
    unicode: "\u04DC",
    horizAdvX: 846,
    d: "M372 667h102v-269l238 269h124l-275 -306l281 -361h-126l-226 294l-16 -18v-276h-102v276l-16 18l-226 -294h-126l281 361l-275 306h124l238 -269v269zM263 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM459 795q0 26 18 44t44 18t44 -18t18 -44 t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DD",
    unicode: "\u04DD",
    horizAdvX: 624,
    d: "M263 421h98v-156l127 156h118l-163 -192l179 -229h-122l-127 169l-12 -14v-155h-98v155l-12 14l-127 -169h-122l179 229l-163 192h118l127 -156v156zM160 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM340 569q0 26 18 44t44 18t44 -18t18 -44 t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DE",
    unicode: "\u04DE",
    horizAdvX: 570,
    d: "M137 516l-67 65q37 49 86 72q50 25 121 25q100 0 155 -53q48 -47 48 -117q0 -48 -22 -83q-21 -36 -60 -58q55 -14 90 -59q34 -43 34 -113q0 -90 -67 -149q-68 -58 -180 -58q-95 0 -164 52q-54 42 -85 108l90 46q20 -51 62 -81q44 -31 110 -31t102 36q32 32 32 82 q0 52 -39 78q-37 26 -121 26h-60v96h54q64 0 96 27q30 25 30 68q0 45 -32 69q-26 20 -77 20q-48 0 -81 -19q-32 -18 -55 -49zM120 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM316 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18 t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DF",
    unicode: "\u04DF",
    horizAdvX: 440,
    d: "M119 312l-63 55q24 29 64 47q42 18 99 18q66 0 107 -29q44 -32 44 -86q0 -35 -18 -58q-15 -20 -40 -30q38 -8 61 -31q27 -27 27 -70q0 -57 -36 -93q-48 -48 -148 -48q-67 0 -110 25q-45 26 -66 75l78 40q14 -30 37 -44q25 -16 63 -16q46 0 67 21q15 17 15 37q0 21 -13 34 q-17 18 -70 18h-44v80h37q32 0 48 11q18 14 18 37q0 24 -18 36q-15 11 -47 11q-30 0 -55 -12q-21 -10 -37 -28zM78 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM258 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E2",
    unicode: "\u04E2",
    horizAdvX: 712,
    d: "M530 0v449l-450 -479v697h102v-451l450 479v-695h-102zM184 733v80h360v-80h-360z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E3",
    unicode: "\u04E3",
    horizAdvX: 510,
    d: "M62 421h98v-239l288 277v-459h-98v245l-288 -277v453zM90 508v78h330v-78h-330z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E4",
    unicode: "\u04E4",
    horizAdvX: 712,
    d: "M530 0v449l-450 -479v697h102v-451l450 479v-695h-102zM204 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM400 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E5",
    unicode: "\u04E5",
    horizAdvX: 510,
    d: "M62 421h98v-239l288 277v-459h-98v245l-288 -277v453zM103 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM283 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E6",
    unicode: "\u04E6",
    horizAdvX: 790,
    d: "M395 679q149 0 248 -99t99 -247t-99 -247t-248 -99t-248 99t-99 247t99 247t248 99zM395 81q107 0 176 70.5t69 181.5t-69 181.5t-176 70.5t-176 -70.5t-69 -181.5t69 -181.5t176 -70.5zM235 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM431 795 q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E7",
    unicode: "\u04E7",
    horizAdvX: 530,
    d: "M265 432q96 0 160.5 -62.5t64.5 -159.5q0 -96 -64.5 -159.5t-160.5 -63.5t-160.5 63.5t-64.5 159.5q0 97 64.5 159.5t160.5 62.5zM265 75q57 0 91 36.5t34 97.5q0 67 -36.5 101t-88.5 34t-88.5 -34t-36.5 -101q0 -61 34 -97.5t91 -36.5zM113 569q0 26 18 44t44 18t44 -18 t18 -44t-18 -44t-44 -18t-44 18t-18 44zM293 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E8",
    unicode: "\u04E8",
    horizAdvX: 790,
    d: "M395 679q149 0 248 -99t99 -247t-99 -247t-248 -99t-248 99t-99 247t99 247t248 99zM637 287h-484q12 -88 78.5 -147t163.5 -59t163.5 59t78.5 147zM153 383h484q-12 85 -78.5 143.5t-163.5 58.5t-163.5 -58.5t-78.5 -143.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E9",
    unicode: "\u04E9",
    horizAdvX: 530,
    d: "M265 432q96 0 160.5 -62.5t64.5 -159.5q0 -96 -64.5 -159.5t-160.5 -63.5t-160.5 63.5t-64.5 159.5q0 97 64.5 159.5t160.5 62.5zM386 173h-242q8 -47 41.5 -72.5t79.5 -25.5t79.5 25.5t41.5 72.5zM144 253h242q-9 41 -40.5 66t-80.5 25t-80.5 -25t-40.5 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EA",
    unicode: "\u04EA",
    horizAdvX: 790,
    d: "M395 679q149 0 248 -99t99 -247t-99 -247t-248 -99t-248 99t-99 247t99 247t248 99zM637 287h-484q12 -88 78.5 -147t163.5 -59t163.5 59t78.5 147zM153 383h484q-12 85 -78.5 143.5t-163.5 58.5t-163.5 -58.5t-78.5 -143.5zM235 795q0 26 18 44t44 18t44 -18t18 -44 t-18 -44t-44 -18t-44 18t-18 44zM431 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EB",
    unicode: "\u04EB",
    horizAdvX: 530,
    d: "M265 432q96 0 160.5 -62.5t64.5 -159.5q0 -96 -64.5 -159.5t-160.5 -63.5t-160.5 63.5t-64.5 159.5q0 97 64.5 159.5t160.5 62.5zM386 173h-242q8 -47 41.5 -72.5t79.5 -25.5t79.5 25.5t41.5 72.5zM144 253h242q-9 41 -40.5 66t-80.5 25t-80.5 -25t-40.5 -66zM113 569 q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM293 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EE",
    unicode: "\u04EE",
    horizAdvX: 570,
    d: "M6 667h124l172 -356l156 356h106l-301 -667h-106l86 189zM114 733v80h360v-80h-360z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EF",
    unicode: "\u04EF",
    horizAdvX: 482,
    d: "M31 -229l155 295l-180 355h118l120 -246l122 246h110l-335 -650h-110zM76 508v78h330v-78h-330z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F0",
    unicode: "\u04F0",
    horizAdvX: 570,
    d: "M6 667h124l172 -356l156 356h106l-301 -667h-106l86 189zM134 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM330 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F1",
    unicode: "\u04F1",
    horizAdvX: 482,
    d: "M31 -229l155 295l-180 355h118l120 -246l122 246h110l-335 -650h-110zM89 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM269 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F2",
    unicode: "\u04F2",
    horizAdvX: 570,
    d: "M6 667h124l172 -356l156 356h106l-301 -667h-106l86 189zM276 906l78 -52l-156 -127l-44 36zM476 906l78 -52l-156 -127l-44 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F3",
    unicode: "\u04F3",
    horizAdvX: 482,
    d: "M31 -229l155 295l-180 355h118l120 -246l122 246h110l-335 -650h-110zM223 675l82 -46l-146 -144l-42 34zM403 675l82 -46l-146 -144l-42 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F4",
    unicode: "\u04F4",
    horizAdvX: 606,
    d: "M424 0v274q-91 -7 -136 -7q-111 0 -163 41q-65 51 -65 162v197h102v-182q0 -75 36 -103q27 -21 106 -21q57 0 120 7v299h102v-667h-102zM143 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM339 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44 t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F5",
    unicode: "\u04F5",
    horizAdvX: 450,
    d: "M290 0v163q-45 -9 -86 -9q-72 0 -111 31q-41 33 -41 101v135h98v-115q0 -43 25 -58q17 -10 49 -10q36 0 66 11v172h98v-421h-98zM73 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM253 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18 t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F8",
    unicode: "\u04F8",
    horizAdvX: 740,
    d: "M80 0v667h102v-269h76q107 0 167 -53q63 -55 63 -147q0 -48 -21.5 -91.5t-61.5 -70.5q-54 -36 -146 -36h-179zM182 302v-206h72q134 0 134 101q0 44 -29.5 74.5t-102.5 30.5h-74zM558 667h102v-667h-102v667zM205 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18 t-44 18t-18 44zM401 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F9",
    unicode: "\u04F9",
    horizAdvX: 580,
    d: "M62 0v421h98v-149h56q27 0 44 -1.5t41 -11.5t42 -30q33 -37 33 -92q0 -63 -38 -101q-17 -17 -40.5 -25.5t-39 -9.5t-43.5 -1h-153zM160 84h45q36 0 51 9q22 16 22 43q0 28 -21 42q-16 10 -51 10h-46v-104zM420 0v421h98v-421h-98zM143 569q0 26 18 44t44 18t44 -18 t18 -44t-18 -44t-44 -18t-44 18t-18 44zM323 569q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2010",
    unicode: "\u2010",
    horizAdvX: 340,
    d: "M50 162v102h240v-102h-240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2011",
    unicode: "\u2011",
    horizAdvX: 340,
    d: "M50 162v102h240v-102h-240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "figuredash",
    unicode: "\u2012",
    horizAdvX: 620,
    d: "M70 294v90h480v-90h-480z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 620,
    d: "M70 168v90h480v-90h-480z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 840,
    d: "M70 168v90h700v-90h-700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii00208",
    unicode: "\u2015",
    horizAdvX: 840,
    d: "M70 168v90h700v-90h-700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 290,
    d: "M240 667l-102 -254l-88 34l124 247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 290,
    d: "M50 447l102 254l88 -34l-124 -247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 340,
    d: "M50 -129l102 254l88 -34l-124 -247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 462,
    d: "M412 667l-102 -254l-86 34l123 247zM238 667l-102 -254l-86 34l123 247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 462,
    d: "M50 447l102 254l86 -34l-123 -247zM224 447l102 254l86 -34l-123 -247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 512,
    d: "M50 -129l102 254l86 -34l-123 -247zM224 -129l102 254l86 -34l-123 -247z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 568,
    d: "M235 516v213h98v-213h138v-94h-138v-599h-98v599h-138v94h138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 568,
    d: "M235 516v213h98v-213h138v-94h-138v-251h138v-94h-138v-254h-98v254h-138v94h138v251h-138v94h138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 1000,
    d: "M360 340q0 58 41 99t99 41t99 -41t41 -99t-41 -99t-99 -41t-99 41t-41 99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 800,
    d: "M80 48q0 25 17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5t-42.5 17.5t-17.5 42.5zM340 48q0 25 17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5t-42.5 17.5t-17.5 42.5zM600 48q0 25 17.5 42.5t42.5 17.5t42.5 -17.5 t17.5 -42.5t-17.5 -42.5t-42.5 -17.5t-42.5 17.5t-17.5 42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1200,
    d: "M194 673q66 0 113.5 -46.5t47.5 -110.5t-47.5 -110.5t-113.5 -46.5t-113.5 46.5t-47.5 110.5t47.5 110.5t113.5 46.5zM194 431q39 0 61 26.5t22 58.5t-22 58.5t-61 26.5t-61 -26.5t-22 -58.5t22 -58.5t61 -26.5zM191 18l381 660l47 -27l-381 -662zM616 307 q66 0 113.5 -46.5t47.5 -110.5t-47.5 -110.5t-113.5 -46.5t-113.5 46.5t-47.5 110.5t47.5 110.5t113.5 46.5zM616 65q39 0 61 26.5t22 58.5t-22 58.5t-61 26.5t-61 -26.5t-22 -58.5t22 -58.5t61 -26.5zM1006 307q66 0 113.5 -46.5t47.5 -110.5t-47.5 -110.5t-113.5 -46.5 t-113.5 46.5t-47.5 110.5t47.5 110.5t113.5 46.5zM1006 65q39 0 61 26.5t22 58.5t-22 58.5t-61 26.5t-61 -26.5t-22 -58.5t22 -58.5t61 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 321,
    d: "M140 219l127 -165l-65 -47l-162 212l162 212l65 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 321,
    d: "M181 219l-127 165l65 47l162 -212l-162 -212l-65 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 230,
    d: "M-100 17l382 661l48 -28l-382 -661z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2070",
    unicode: "\u2070",
    horizAdvX: 370,
    d: "M185 260q-57 0 -98 44q-55 60 -55 163t55 163q41 44 98 44t98 -44q55 -60 55 -163t-55 -163q-41 -44 -98 -44zM185 608q-31 0 -53 -30q-28 -38 -28 -111t28 -111q22 -30 53 -30t53 30q28 38 28 111t-28 111q-22 30 -53 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2074",
    unicode: "\u2074",
    horizAdvX: 370,
    d: "M295 697v-307h43v-66h-43v-57h-72v57h-209zM139 390h84v114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2075",
    unicode: "\u2075",
    horizAdvX: 370,
    d: "M299 667v-66h-126l-17 -61q6 1 19 1q57 0 95 -29q48 -38 48 -105q0 -66 -44 -106.5t-114 -40.5q-91 0 -140 85l56 39q25 -58 85 -58q40 0 62.5 22t22.5 56t-22.5 55.5t-62.5 21.5q-48 0 -76 -34h-27l66 220h175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2076",
    unicode: "\u2076",
    horizAdvX: 370,
    d: "M212 691l61 -43l-89 -128q6 1 18 1q52 0 90 -30.5t38 -92.5q0 -60 -40 -99t-105 -39q-69 0 -107 38.5t-38 90.5q0 54 33 102zM184 457q-31 0 -51.5 -18.5t-20.5 -47.5t21 -48t52 -19t52 19t21 48t-21 47.5t-53 18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2077",
    unicode: "\u2077",
    horizAdvX: 370,
    d: "M34 283l194 318h-192v66h318l-252 -414z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2078",
    unicode: "\u2078",
    horizAdvX: 370,
    d: "M185 674q58 0 92 -34t34 -80q0 -54 -44 -85q55 -25 55 -94q0 -55 -40 -88t-97 -33t-97 33t-40 88q0 69 55 94q-44 31 -44 85q0 46 34 80t92 34zM185 610q-28 0 -43 -16t-15 -37q0 -20 15 -35.5t43 -15.5q27 0 42.5 15t15.5 36t-15 37t-43 16zM185 442q-31 0 -48 -17.5 t-17 -41.5q0 -23 17 -41t48 -18t48 18t17 41q0 24 -17 41.5t-48 17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2079",
    unicode: "\u2079",
    horizAdvX: 370,
    d: "M158 243l-61 43l89 128q-6 -1 -17 -1q-51 0 -90 32t-39 90q0 61 40 100t105 39q69 0 107 -38.5t38 -90.5q0 -56 -33 -102zM186 477q31 0 51.5 18.5t20.5 47.5t-21 48t-52 19t-52 -19t-21 -48t21 -47.5t53 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2080",
    unicode: "\u2080",
    horizAdvX: 370,
    d: "M185 -7q-57 0 -98 44q-55 61 -55 163t55 163q41 44 98 44t98 -44q55 -61 55 -163t-55 -163q-41 -44 -98 -44zM185 341q-31 0 -53 -30q-28 -38 -28 -111t28 -111q22 -30 53 -30t53 30q28 38 28 111t-28 111q-22 30 -53 30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2081",
    unicode: "\u2081",
    horizAdvX: 370,
    d: "M162 0v334h-78l42 66h110v-400h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2082",
    unicode: "\u2082",
    horizAdvX: 370,
    d: "M314 66v-66h-290l146 162q34 38 50 62q21 30 21 57t-17.5 43.5t-45.5 16.5q-32 0 -51 -22t-22 -51h-70q3 58 37 96q38 43 103 43t101.5 -36t36.5 -88q0 -36 -30 -85q-19 -30 -55 -70l-55 -62h141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2083",
    unicode: "\u2083",
    horizAdvX: 370,
    d: "M115 286h-70q3 41 23 70q33 51 110 51q63 0 95 -32.5t32 -79.5q0 -62 -52 -84q11 -4 21.5 -10.5t24 -28.5t13.5 -52q0 -53 -36.5 -90t-104.5 -37q-95 0 -128 78q-10 24 -11 48h70q6 -60 69 -60q34 0 51.5 18t17.5 44q0 12 -3.5 23t-20 23t-45.5 12h-24v66h24q63 0 63 47 q0 24 -16 36.5t-42 12.5q-28 0 -43.5 -15t-17.5 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2084",
    unicode: "\u2084",
    horizAdvX: 370,
    d: "M295 430v-307h43v-66h-43v-57h-72v57h-209zM139 123h84v114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2085",
    unicode: "\u2085",
    horizAdvX: 370,
    d: "M299 400v-66h-126l-17 -61q6 1 19 1q57 0 95 -29q48 -38 48 -105q0 -66 -44 -106.5t-114 -40.5q-91 0 -140 85l56 39q25 -58 85 -58q40 0 62.5 22t22.5 56t-22.5 55.5t-62.5 21.5q-48 0 -76 -34h-27l66 220h175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2086",
    unicode: "\u2086",
    horizAdvX: 370,
    d: "M212 424l61 -43l-89 -128q6 1 18 1q52 0 90 -30.5t38 -92.5q0 -61 -40 -99.5t-105 -38.5q-69 0 -107 38.5t-38 90.5q0 54 33 102zM184 190q-31 0 -51.5 -18.5t-20.5 -47.5t21 -48t52 -19t52 19t21 48t-21 47.5t-53 18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2087",
    unicode: "\u2087",
    horizAdvX: 370,
    d: "M34 16l194 318h-192v66h318l-252 -414z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2088",
    unicode: "\u2088",
    horizAdvX: 370,
    d: "M185 407q58 0 92 -34t34 -80q0 -54 -44 -85q55 -25 55 -94q0 -55 -40 -88t-97 -33t-97 33t-40 88q0 69 55 94q-44 31 -44 85q0 46 34 80t92 34zM185 343q-28 0 -43 -16t-15 -37q0 -20 15 -35.5t43 -15.5q27 0 42.5 15.5t15.5 35.5q0 21 -15 37t-43 16zM185 175 q-31 0 -48 -17.5t-17 -41.5q0 -23 17 -41t48 -18t48 18t17 41q0 24 -17 41.5t-48 17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2089",
    unicode: "\u2089",
    horizAdvX: 370,
    d: "M158 -24l-61 43l89 128q-6 -1 -17 -1q-51 0 -90 32t-39 90q0 61 40 100t105 39q69 0 107 -38.5t38 -90.5q0 -56 -33 -102zM186 210q31 0 51.5 18.5t20.5 47.5t-21 48t-52 19t-52 -19t-21 -48t21 -47.5t53 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 568,
    d: "M542 641l-43 -89q-48 33 -118 33q-79 0 -135.5 -36.5t-78.5 -102.5h291l-30 -70h-275q-5 -39 -1 -74h247l-30 -70h-207q17 -70 75 -110.5t135 -40.5q87 0 160 57v-109q-81 -42 -163 -42q-144 0 -229 82q-68 64 -82 163h-68l30 70h30q-4 35 1 74h-61l30 70h41 q22 86 82 146q88 87 241 87q92 0 158 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B4",
    unicode: "\u20B4",
    horizAdvX: 568,
    d: "M80 567q36 48 83 76q58 36 133 36q76 0 120 -36q44 -35 44 -90q0 -57 -47 -106h111v-70h-164l-72 -74h236v-70h-297q-41 -35 -41 -83q0 -29 22 -49q24 -20 68 -20q54 0 93 31q33 27 47 62l85 -40q-22 -55 -72 -95q-65 -52 -161 -52q-78 0 -124 33q-60 42 -60 114 q0 55 39 99h-83v70h138l72 74h-210v70h269q49 35 49 80q0 26 -16 41q-18 17 -55 17q-38 0 -73 -20q-34 -20 -52 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20B6",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CF",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CE",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CD",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CC",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CB",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CA",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C9",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C8",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C7",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C6",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C5",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C4",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C3",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C2",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C1",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C0",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BF",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BE",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BD",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BC",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BB",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BA",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20B9",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20B7",
    horizAdvX: 568,
    d: "M281 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM236 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B8",
    unicode: "\u20B8",
    horizAdvX: 568,
    d: "M488 441h-153v-441h-102v441h-153v96h408v-96zM488 581h-408v86h408v-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1060,
    d: "M182 0h-102v712l444 -483v438h102v-708l-444 483v-442zM857 667q66 0 113.5 -46.5t47.5 -110.5t-47.5 -110.5t-113.5 -46.5t-113.5 46.5t-47.5 110.5t47.5 110.5t113.5 46.5zM857 425q39 0 61 26.5t22 58.5t-22 58.5t-61 26.5t-61 -26.5t-22 -58.5t22 -58.5t61 -26.5z M716 203v80h282v-80h-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2117",
    unicode: "\u2117",
    horizAdvX: 758,
    d: "M274 527h109q62 0 94 -31q30 -28 30 -80q0 -51 -28 -80q-33 -35 -112 -35h-22v-148h-71v374zM345 464v-104h14q40 0 60 15q18 14 18 41q0 25 -19 39q-14 9 -49 9h-24zM379 630q-122 0 -206 -84t-84 -213t84 -213t206 -84t206 84t84 213t-84 213t-206 84zM725 333 q0 -151 -98 -249t-248 -98t-248 98t-98 249t98 249t248 98t248 -98t98 -249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 710,
    d: "M238 601h-84v-314h-70v314h-84v66h238v-66zM331 287h-71l82 414l126 -280l127 280l81 -414h-71l-35 206l-102 -213l-102 213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 530,
    d: "M96 586l18 87q123 -15 213 -76q78 -54 118 -135q45 -89 45 -212q0 -137 -66 -204q-59 -59 -157 -59q-100 0 -162 63q-65 66 -65 160q0 100 64 164q58 58 142 58q78 0 131 -47q-27 96 -114 148q-76 46 -167 53zM265 75q56 0 86 30q39 37 39 104t-40 104q-35 31 -85 31 q-52 0 -85 -31q-40 -40 -40 -104q0 -69 40 -105q33 -29 85 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 714,
    d: "M38 654v96h638v-96h-80v-808h80v-96h-263v96h81v808h-273v-808h80v-96h-263v96h81v808h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 700,
    d: "M32 750h598v-245h-94v149h-364l220 -382l-220 -426h372v147h94v-243h-606v46l252 476l-252 432v46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    d: "M33 291v90h434v-90h-434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 684,
    d: "M0 -177l526 942l80 -36l-526 -942z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 200,
    d: "M22 340q0 33 22.5 55.5t55.5 22.5t55.5 -22.5t22.5 -55.5t-22.5 -55.5t-55.5 -22.5t-55.5 22.5t-22.5 55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 668,
    d: "M394 827h274v-88h-190l-193 -739h-126l-71 286h-88v88h168l50 -251h8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 670,
    d: "M335 275q-67 -93 -162 -93q-68 0 -111.5 44t-43.5 113q0 70 43.5 114.5t112.5 44.5q98 0 161 -93q63 93 161 93q69 0 112.5 -44.5t43.5 -114.5q0 -69 -43.5 -113t-111.5 -44q-95 0 -162 93zM482 410q-27 0 -53.5 -20.5t-44.5 -49.5q17 -30 44 -50t54 -20q31 0 51 20 t20 50q0 29 -21 49.5t-50 20.5zM188 270q27 0 54 20t44 50q-18 29 -44.5 49.5t-53.5 20.5q-29 0 -50 -20.5t-21 -49.5q0 -30 20 -50t51 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    d: "M75 -239l18 86q24 -13 53 -13q26 0 40 15t14 87v618q0 37 1 55.5t8.5 47t23.5 47.5q40 46 117 46q41 0 75 -11l-18 -86q-24 13 -53 13q-26 0 -40 -15t-14 -87v-618q0 -37 -1 -55.5t-8.5 -47t-23.5 -47.5q-40 -46 -117 -46q-41 0 -75 11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    d: "M435 505l57 -33q-26 -62 -66 -93q-36 -28 -83 -28q-36 0 -112 32q-61 26 -87 26q-31 0 -51 -22q-18 -18 -29 -45l-56 36q21 51 50 83q37 42 92 42q38 0 110 -31q65 -28 93 -28q29 0 49 18q20 17 33 43zM435 323l57 -33q-26 -62 -66 -93q-36 -28 -83 -28q-36 0 -112 32 q-61 26 -87 26q-31 0 -51 -22q-18 -18 -29 -45l-56 36q21 51 50 83q37 42 92 42q38 0 110 -31q65 -28 93 -28q29 0 49 18q20 17 33 43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    d: "M33 380v84h238l52 110h78l-52 -110h118v-84h-158l-37 -78h195v-84h-235l-55 -116h-78l55 116h-121v84h161l37 78h-198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    d: "M137 391l330 -149v-92l-434 200v82l434 200v-92zM467 32h-434v90h434v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    d: "M363 391l-330 149v92l434 -200v-82l-434 -200v92zM467 32h-434v90h434v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotmath",
    unicode: "\u22C5",
    horizAdvX: 200,
    d: "M22 340q0 33 22.5 55.5t55.5 22.5t55.5 -22.5t22.5 -55.5t-22.5 -55.5t-55.5 -22.5t-55.5 22.5t-22.5 55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 700,
    d: "M90 334l260 360l260 -360l-260 -360zM496 334l-146 202l-146 -202l146 -202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "openbullet",
    unicode: "\u25E6",
    d: "M104 522q0 61 42 103t104 42t104 -42t42 -103t-42 -103t-104 -42t-104 42t-42 103zM166 522q0 -37 24.5 -62t59.5 -25t59.5 25t24.5 62t-24.5 62t-59.5 25t-59.5 -25t-24.5 -62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF400",
    unicode: "\uF400",
    horizAdvX: 2,
    d: "M-173 675l90 -46l-156 -144l-54 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF401",
    unicode: "\uF401",
    horizAdvX: 2,
    d: "M-314 727l-48 40l138 139l86 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF406",
    unicode: "\uF406",
    d: "M338 874h82q-9 -49 -40 -86q-48 -58 -130 -58t-130 58q-31 37 -40 86h82q9 -33 34 -49q22 -15 54 -15t54 15q25 16 34 49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF407",
    unicode: "\uF407",
    d: "M290 -53l86 -38l-112 -133l-64 32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF408",
    unicode: "\uF408",
    d: "M250 812l-99 -82l-66 56l165 134l165 -134l-66 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF409",
    unicode: "\uF409",
    d: "M170 -242l72 192l88 -34l-90 -186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40A",
    unicode: "\uF40A",
    d: "M150 468l82 212l88 -34l-104 -206z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40B",
    unicode: "\uF40B",
    d: "M183 801q0 29 19.5 48t47.5 19t47.5 -19t19.5 -48t-19.5 -48t-47.5 -19t-47.5 19t-19.5 48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40C",
    unicode: "\uF40C",
    d: "M153 823q0 41 28.5 69t68.5 28t68.5 -28t28.5 -69q0 -40 -28 -68.5t-69 -28.5q-40 0 -68.5 28.5t-28.5 68.5zM207 823q0 -18 12.5 -30.5t30.5 -12.5t30.5 12.5t12.5 30.5t-12.5 30.5t-30.5 12.5t-30.5 -12.5t-12.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40D",
    unicode: "\uF40D",
    d: "M372 863l58 -46q-41 -84 -116 -84q-27 0 -55 13q-12 6 -20.5 10t-12 6t-9.5 4q-25 9 -37 9q-36 0 -51 -42l-59 41q19 34 42 54q32 27 70 27q22 0 49 -9q32 -14 46 -21q28 -14 41 -14q39 0 54 52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40E",
    unicode: "\uF40E",
    d: "M246 0h78q-31 -17 -51 -39q-21 -23 -21 -45q0 -31 40 -31q24 0 52 7l-9 -70q-31 -15 -66 -15q-41 0 -70 24t-29 64q0 34 26 64q19 22 50 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4C6",
    unicode: "\uF4C6",
    horizAdvX: 606,
    d: "M60 667h102v-182q0 -75 36 -103q27 -21 106 -21q57 0 120 7v299h102v-753q0 -82 -44 -117q-33 -27 -94 -27q-36 0 -66 9v92q23 -9 47 -9q33 0 46 22q9 15 9 60v330q-91 -7 -136 -7q-111 0 -163 41q-65 51 -65 162v197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4C7",
    unicode: "\uF4C7",
    horizAdvX: 450,
    d: "M290 421h98v-507q0 -83 -44 -117q-34 -27 -90 -27q-42 0 -66 9v88q22 -9 47 -9q33 0 46 22q9 15 9 60v223q-45 -9 -86 -9q-72 0 -111 31q-41 33 -41 101v135h98v-115q0 -43 25 -58q17 -10 49 -10q36 0 66 11v172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4CC",
    unicode: "\uF4CC",
    horizAdvX: 570,
    d: "M6 667h124l172 -356l156 356h106l-301 -667h-106l86 189zM272 727l-48 40l138 139l86 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4CD",
    unicode: "\uF4CD",
    horizAdvX: 482,
    d: "M31 -229l155 295l-180 355h118l120 -246l122 246h110l-335 -650h-110zM316 675l90 -46l-156 -144l-54 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar.fitted",
    unicode: "\uF5F5",
    horizAdvX: 455,
    d: "M422 567l-82 -48q-10 24 -30 42q-28 24 -72 24q-47 0 -74 -27q-20 -20 -20 -51q0 -34 26 -56q20 -17 63 -34l50 -20q76 -31 111 -70q46 -51 46 -126q0 -90 -58 -152q-46 -49 -110 -58v-101h-74v98q-77 6 -130 66q-49 55 -56 130l101 22q0 -48 28 -85q32 -40 87 -40 q48 0 79 32q31 31 31 80q0 43 -29 73q-19 20 -67 41l-64 27q-58 25 -94 61q-42 43 -42 102q0 80 51 129q43 41 105 50v89h74v-88q48 -4 87 -33q41 -32 63 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro.fitted",
    unicode: "\uF5F6",
    horizAdvX: 598,
    d: "M568 641l-43 -89q-48 33 -118 33q-79 0 -135.5 -36.5t-78.5 -102.5h291l-30 -70h-275q-5 -39 -1 -74h247l-30 -70h-207q17 -70 75 -110.5t135 -40.5q87 0 160 57v-109q-81 -42 -163 -42q-144 0 -229 82q-68 64 -82 163h-68l30 70h30q-4 35 1 74h-61l30 70h41 q22 86 82 146q88 87 241 87q92 0 158 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent.fitted",
    unicode: "\uF5F7",
    horizAdvX: 377,
    d: "M359 527v-109q-48 51 -122 51q-53 0 -87 -34q-39 -37 -39 -100q0 -64 38 -100q37 -35 92 -35q70 0 118 54v-109q-44 -29 -94 -32v-100h-74v103q-71 11 -120 60q-60 60 -60 158q0 102 68 166q48 46 112 54v101h74v-99q49 -4 94 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling.fitted",
    unicode: "\uF5F8",
    horizAdvX: 560,
    d: "M512 444h-98v4q0 70 -35 105q-31 31 -80 31q-53 0 -86 -31q-33 -33 -33 -81q0 -45 51 -142h130v-72h-101q12 -36 12 -65q0 -34 -14 -65l53 -19q60 -20 76 -20q48 0 69 63l82 -48q-22 -46 -51 -75q-38 -38 -97 -38q-40 0 -112 25q-76 28 -101 28q-49 0 -68 -59l-87 44 q26 56 70 87q30 20 63 22q15 30 15 62q0 34 -15 58h-114v72h78q-41 86 -41 141q0 87 57 144q65 63 165 63q95 0 151 -56q61 -61 61 -173v-5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen.fitted",
    unicode: "\uF5F9",
    horizAdvX: 542,
    d: "M510 377h-143l-41 -74h184v-70h-192v-233h-94v233h-192v70h184l-41 74h-143v70h104l-121 220h110l146 -267l146 267h110l-121 -220h104v-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin.fitted",
    unicode: "\uF5FA",
    d: "M494 731l-18 -93q-21 10 -44 10q-32 0 -51 -21q-18 -21 -28 -74l-24 -132h112l-14 -78h-112l-51 -279q-9 -48 -14.5 -72t-21 -59.5t-36.5 -55.5q-64 -62 -186 -53l16 93h6q63 0 90 27q27 26 44 119l51 280h-85l14 78h85l26 144q16 90 58 132q43 43 115 43q36 0 68 -9z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B4.fitted",
    unicode: "\uF5FB",
    horizAdvX: 523,
    d: "M60 567q36 48 83 76q58 36 133 36q76 0 120 -36q44 -35 44 -90q0 -57 -47 -106h111v-70h-164l-72 -74h236v-70h-297q-41 -35 -41 -83q0 -29 22 -49q24 -20 68 -20q54 0 93 31q33 27 47 62l85 -40q-22 -55 -72 -95q-65 -52 -161 -52q-78 0 -124 33q-60 42 -60 114 q0 55 39 99h-83v70h138l72 74h-210v70h269q49 35 49 80q0 26 -16 41q-18 17 -55 17q-38 0 -73 -20q-34 -20 -52 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6.fitted",
    unicode: "\uF5FC",
    horizAdvX: 480,
    d: "M240 667q92 0 146 -36q41 -26 62 -69t21 -87q0 -84 -53 -137q-61 -61 -175 -61h-46v-74h158v-70h-158v-133h-102v133h-73v70h73v74h-73v88h73v302h147zM195 573v-208h46q70 0 104 34q26 26 26 71q0 44 -28 72q-32 31 -103 31h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B8.fitted",
    unicode: "\uF5FD",
    horizAdvX: 432,
    d: "M420 441h-153v-441h-102v441h-153v96h408v-96zM420 581h-408v86h408v-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF639",
    unicode: "\uF639",
    horizAdvX: 522,
    d: "M261 -11q-88 0 -151 72q-85 97 -85 272q0 176 85 273q63 72 151 72t151 -72q85 -97 85 -273q0 -175 -85 -272q-63 -72 -151 -72zM261 588q-54 0 -90 -55q-46 -68 -46 -199q0 -130 46 -200q36 -55 90 -55t90 55q46 70 46 200q0 131 -46 199q-36 55 -90 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63A",
    unicode: "\uF63A",
    horizAdvX: 496,
    d: "M469 94v-94h-448l231 280q52 63 80 104q35 52 35 96q0 45 -29 76.5t-82 31.5t-84 -35t-34 -86h-98q4 88 56 146q58 65 156 65q101 0 158 -59t57 -142q0 -69 -48 -140q-26 -39 -95 -120l-104 -123h249z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63B",
    unicode: "\uF63B",
    horizAdvX: 472,
    d: "M138 497h-98q4 79 57 130t146 51q91 0 144 -55q48 -49 48 -127q0 -50 -23 -88q-23 -36 -60 -56q42 -16 66 -53q28 -41 28 -103q0 -92 -57 -149q-58 -58 -163 -58q-97 0 -149 56q-49 52 -57 136h98q8 -45 36 -72q32 -30 81 -30q47 0 78 28q35 33 35 94q0 50 -30 79 q-31 30 -86 30h-20v86h14q56 0 85 29q26 26 26 71q0 41 -26 67q-26 25 -71 25q-48 0 -74 -27q-10 -11 -17 -26.5t-9 -24.5t-2 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63C",
    unicode: "\uF63C",
    horizAdvX: 522,
    d: "M429 716v-496h72v-94h-72v-126h-98v126h-330zM179 218h152v215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63D",
    unicode: "\uF63D",
    d: "M463 667v-94h-206l-33 -111q20 2 31 2q94 0 154 -59q65 -63 65 -171q0 -109 -68 -177q-69 -68 -185 -68q-76 0 -128 30q-48 29 -79 77l77 64q14 -34 51 -58q34 -23 87 -23q63 0 102 37q43 43 43 113t-40 108q-39 37 -109 37q-40 0 -78 -14q-34 -13 -59 -30l99 337h276z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63E",
    unicode: "\uF63E",
    horizAdvX: 502,
    d: "M313 690l74 -55l-159 -201q20 4 42 4q94 0 154 -62q59 -62 59 -156q0 -103 -66 -168q-64 -63 -172 -63q-109 0 -172 65q-58 61 -58 151q0 66 32 128q7 14 14.5 26.5t17 26.5t14.5 20.5t18.5 24t16.5 21.5zM250 351q-57 0 -96 -37t-39 -99q0 -61 39 -99q39 -37 96 -37 t94 37q39 39 39 99t-39 99q-37 37 -94 37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63F",
    unicode: "\uF63F",
    horizAdvX: 529,
    d: "M27 27l332 546h-328v94h496l-420 -690z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF640",
    unicode: "\uF640",
    horizAdvX: 470,
    d: "M235 303q-48 0 -79 -31t-31 -81q0 -45 30 -78q30 -34 80 -34t80 34q30 33 30 78q0 50 -31 81t-79 31zM235 588q-44 0 -73 -27q-28 -28 -28 -74q0 -43 27 -70q28 -30 74 -30t74 30q27 27 27 70q0 46 -28 74q-29 27 -73 27zM345 347q45 -19 70 -54q30 -40 30 -100 q0 -87 -53 -142q-58 -62 -157 -62t-157 62q-53 55 -53 142q0 60 30 100q25 35 70 54q-36 15 -59 50q-24 38 -24 91q0 85 56 139q54 51 137 51t137 -51q56 -54 56 -139q0 -53 -24 -91q-23 -35 -59 -50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF641",
    unicode: "\uF641",
    horizAdvX: 501,
    d: "M189 -23l-74 55l157 201q-17 -4 -36 -4q-94 0 -156 62q-61 61 -61 152q0 99 66 167t172 68q108 0 172 -66q58 -60 58 -151q0 -65 -32 -127q-7 -14 -14.5 -26.5t-17 -26.5t-14.5 -20.5t-18.5 -24t-16.5 -21.5zM252 316q57 0 96 40q39 41 39 99t-39 95q-40 38 -95 38 t-95 -38q-39 -39 -39 -98q0 -60 39 -99q39 -37 94 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6BA",
    unicode: "\uF6BA",
    horizAdvX: 340,
    d: "M50 288v102h240v-102h-240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6BB",
    unicode: "\uF6BB",
    horizAdvX: 620,
    d: "M70 294v90h480v-90h-480z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6BC",
    unicode: "\uF6BC",
    horizAdvX: 840,
    d: "M70 294v90h700v-90h-700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6C3",
    unicode: "\uF6C3",
    d: "M170 -242l72 192l88 -34l-90 -186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6C9",
    unicode: "\uF6C9",
    d: "M234 727l-48 40l138 139l86 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CA",
    unicode: "\uF6CA",
    d: "M250 838l99 82l66 -56l-165 -134l-165 134l66 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CB",
    unicode: "\uF6CB",
    d: "M90 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44zM286 795q0 26 18 44t44 18t44 -18t18 -44t-18 -44t-44 -18t-44 18t-18 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CE",
    unicode: "\uF6CE",
    d: "M266 727l-176 119l86 60l138 -139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CF",
    unicode: "\uF6CF",
    d: "M232 906l78 -52l-156 -127l-44 36zM432 906l78 -52l-156 -127l-44 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6D0",
    unicode: "\uF6D0",
    d: "M70 733v80h360v-80h-360z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6D1",
    unicode: "\uF6D1",
    d: "M85 832l80 36q6 -19 18.5 -31.5t28 -17t23.5 -6t15 -1.5t15 1.5t23.5 6t28 17t18.5 31.5l80 -36q-23 -56 -69.5 -79t-95.5 -23t-95.5 23t-69.5 79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6D4",
    unicode: "\uF6D4",
    d: "M88 603l80 23q19 -65 82 -65q62 0 82 65l80 -23q-16 -57 -64.5 -87.5t-97.5 -30.5t-97.5 30.5t-64.5 87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6DC",
    unicode: "\uF6DC",
    horizAdvX: 259,
    d: "M121 0v573h-116l56 94h162v-667h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6DE",
    unicode: "\uF6DE",
    horizAdvX: 630,
    d: "M52 168v90h525v-90h-525z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nbspace",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphenminus",
    horizAdvX: 340,
    d: "M50 162v102h240v-102h-240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi1",
    horizAdvX: 222,
    d: "M62 421h98v-421h-98v421z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "S",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "O",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "G",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "Q",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u04DD",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u04DC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u04AF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0497",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0496",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0436",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0434",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0416",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0414",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u040B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0409",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: ".",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "1",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: ",",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "9",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "8",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "7",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "6",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "5",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "4",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "2",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "1",
    k: 212
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "0",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: ".",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "9",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "8",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "7",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "6",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "4",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "1",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "4",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "1",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "1",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "1",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "7",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "4",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "1",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ".",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ",",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ":",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "9",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "8",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "6",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "2",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "1",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "9",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "4",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "2",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "1",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "8",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "5",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "1",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "Y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2039",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201C",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2018",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "J",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: ".",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "*",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "Y",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "W",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "O",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "hyphenminus",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uF6BC",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uF6BB",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uF6BA",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2014",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2013",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2012",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2011",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2010",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "g",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "d",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "S",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "-",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2026",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "J",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u201D",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "q",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "p",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "Q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "J",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "x",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Q",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "*",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "w",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "Y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "N",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201D",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "M",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "F",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "y",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "w",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "t",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ";",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ":",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "hyphenminus",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2122",
    k: -93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2026",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "v",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 124
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "W",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2122",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u2122",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "X",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "M",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2026",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "p",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "m",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "Q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u2122",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2122",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2026",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "p",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "m",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "Q",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "J",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ":",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2122",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2026",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "p",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "m",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "Q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "M",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "J",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ".",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\uF6BC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\uF6BB",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\uF6BA",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2014",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2013",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2012",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2011",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2010",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "s",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "S",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "-",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "Q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2026",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "x",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "m",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "Q",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "M",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "J",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ":",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "v",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "q",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "Q",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u201D",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u2018",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "J",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "v",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "f",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "X",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "Q",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "J",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\u201D",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\u2019",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "Y",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "q",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "q",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "w",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "Y",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "v",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "Y",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "Y",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "J",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u2026",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "v",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "q",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "v",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "q",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "J",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "v",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "Q",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "y",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "u",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "e",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "a",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "Y",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ",",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2026",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "q",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "u",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "o",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "c",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "a",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "Y",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "A",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    g2: "hyphenminus",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "v",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    g2: "afii10032.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    g2: "afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04EA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04E8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04E6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04D8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04D2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04D0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04AA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0421",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u041E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0410",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0404",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04F4",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04B8",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04B6",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0472",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u042A",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10071.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10097.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10095.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10080.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10049.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10047.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u2122",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u2026",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u201C",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04F5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04EB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04E9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04E7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04E5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04E3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04DD",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04C4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04B9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04B7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04B3",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04AF",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04AB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u049D",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u049B",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0497",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0473",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0472",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u045E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0458",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0457",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0456",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0454",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u044F",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u044D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u044A",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0447",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0445",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0444",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0442",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0441",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u043E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0436",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0434",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u042F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u042D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u042A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0424",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u041C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0414",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u040B",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0409",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0402",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: ":",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u201D",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u2019",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u2122",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u201C",
    k: -93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u2018",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04F5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0447",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0406",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0407",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0407",
    u2: "\u0407",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    g2: "afii10017.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04D2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04D0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04F4",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04B8",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04B6",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u042A",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0427",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0402",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u201D",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u2019",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u2018",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04F4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04B8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04B6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u042A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0427",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0402",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u04F4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u04B8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u04B6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0427",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10085.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10074.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10065.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10032.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04EF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04EA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04C8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04BB",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04A3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0458",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0457",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0452",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0448",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0446",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0443",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0440",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0439",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0438",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0432",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0430",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u041E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10096.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10093.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10049.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10047.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F5",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04C4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u049D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u049B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0453",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0449",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0447",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0441",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u042D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0424",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0404",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: ";",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: ":",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10097.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10080.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u2026",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04F9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04F5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04EB",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04DD",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04C8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04C4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04AB",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04A3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u049D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u049B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0497",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0473",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0458",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0457",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0455",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0441",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0436",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0434",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0431",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0409",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: ".",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040F",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    g2: "hyphenminus",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u201C",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u2018",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04F5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04DD",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04AF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04AE",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0497",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0436",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0424",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0414",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0402",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: ".",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "*",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10047.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10032.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04F2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04F0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04EE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04EA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04E8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04E6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04DE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04D8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04D2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04D0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04AE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0498",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0423",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u041E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0417",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0410",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04F4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04AA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0427",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0421",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0414",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0404",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10071.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10097.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10095.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10080.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10049.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10047.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u2122",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u2026",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u201C",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04F5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04EB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04E9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04E7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04E5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04E3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04DD",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04C4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04B9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04B7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04B3",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04AF",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04AB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u049D",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u049B",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0497",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0473",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0472",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u045E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0458",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0457",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0456",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0454",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044F",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044A",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0447",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0445",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0444",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0442",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0441",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0436",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0434",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u042F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u042A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0424",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u041C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0414",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u040B",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0409",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0402",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: ":",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    g2: "hyphenminus",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\uF6BC",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\uF6BB",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\uF6BA",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    g2: "afii10017.var.accented",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2014",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2013",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2012",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2011",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2010",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04D2",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04D0",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u041B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0410",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "-",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2122",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0434",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0414",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0409",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04F5",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04F4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04AB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0453",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0447",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0441",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0427",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0424",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0404",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    g2: "afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04D2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04D0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0410",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0418",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0419",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10085.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10074.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10065.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10032.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04EF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04EA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04C8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04BB",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04AF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04A3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0458",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0457",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0452",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0448",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0446",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0443",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0440",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0439",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0438",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0432",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0430",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u041E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10096.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10093.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10049.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10047.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F5",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04C4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04AB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u049D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u049B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0453",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0449",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0447",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0441",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u042D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0424",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0404",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    g2: "hyphenminus",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\uF6BC",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\uF6BB",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\uF6BA",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2014",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2013",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2012",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2011",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2010",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "-",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2122",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0422",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u042A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041D",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u041C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0416",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0414",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041F",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10085.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10017.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04F3",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04F1",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04EF",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04BB",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04AF",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u045E",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u045B",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0452",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0443",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u043B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0422",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u041B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0410",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u040B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0402",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: ";",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: ":",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: ",",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u2026",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0459",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0434",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0414",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0409",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: ".",
    k: 124
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04F5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0447",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10096.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10093.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10085.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10080.var.accented",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10074.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10070.var.accented",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10065.var.accented",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10037.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10032.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10017.var.accented",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F0",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EE",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04DF",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04C8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AE",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04A3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0499",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0493",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0491",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0459",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0453",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0452",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0451",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0449",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0448",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0446",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0444",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0443",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0441",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0440",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0439",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0438",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0437",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0435",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0433",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0432",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0430",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0423",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0422",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0421",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u041E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u041B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0410",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u040E",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0404",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ";",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ":",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ".",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ",",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "hyphenminus",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10071.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10097.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10095.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u2122",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u2026",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u201D",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u201C",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04DD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04C4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AF",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u049D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u049B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0497",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0473",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0472",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0457",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0456",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0455",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0445",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0442",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0436",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0434",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0431",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042A",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u040B",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0409",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0402",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    g2: "afii10097.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    g2: "afii10080.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u2026",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04F9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04F5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04EB",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04DD",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04C8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04C4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04AB",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04A3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u049D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u049B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0497",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0473",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0458",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0457",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0455",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0441",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0436",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0434",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0431",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0409",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: ".",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10037.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10017.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u201D",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u2019",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04F2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04F0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04EE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04DF",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04D2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04D0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0499",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0437",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0423",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u041B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0410",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u040E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u201C",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04F4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04B8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04B6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0427",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0420",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0409",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10032.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04EA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04E8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04E6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04D8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04BB",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04AA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u045B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0452",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0421",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u041E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0404",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0427",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    g2: "hyphenminus",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\uF6BC",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\uF6BB",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\uF6BA",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    g2: "afii10017.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u201D",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2019",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2014",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2013",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2012",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2011",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2010",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04D2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04D0",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0410",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "-",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04F5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04F4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04B9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04B8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04B7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u04B6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0434",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0427",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0427",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0428",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u201D",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2019",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0434",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0414",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04F4",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04B8",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04B6",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u042A",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0427",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0402",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042B",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    g2: "afii10017.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04D2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04D0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04F4",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04DC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04B8",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04B6",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0496",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042A",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0427",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0416",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0402",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u201D",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u2019",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u201C",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u2018",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0416",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0414",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u201D",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u2019",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u041C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0416",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0414",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u201C",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u2018",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04DC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0496",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0416",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u2026",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04B2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04AA",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0442",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u043C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0434",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0431",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0425",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0421",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u041C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0414",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: ":",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: ".",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    g2: "hyphenminus",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\uF6BC",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\uF6BB",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\uF6BA",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2014",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2013",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2012",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2011",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2010",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u043B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0422",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u041B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u040B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0409",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0402",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "-",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2018",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u043C",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0434",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u04DC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u0496",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u0416",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0459",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\uF6BC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\uF6BB",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\uF6BA",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u2014",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u2013",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u2012",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u2011",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u2010",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "-",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0459",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0442",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0434",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    g2: "hyphenminus",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\uF6BC",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\uF6BB",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\uF6BA",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    g2: "afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2014",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2013",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2012",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2011",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2010",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04F2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04F0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04EE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04AE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0423",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u040E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "-",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u201C",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    g2: "afii10095.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    g2: "afii10037.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04F2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04F0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04EE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04DF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0499",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0459",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u043B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0437",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0422",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0402",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u201C",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u2018",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0434",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    g2: "hyphenminus",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\uF6BC",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\uF6BB",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\uF6BA",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2014",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2013",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2012",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2011",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2010",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "-",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: ",",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u2026",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: ".",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0442",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\uF6BC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\uF6BB",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\uF6BA",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10071.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10085.var.accented",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10080.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10070.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10065.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10032.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10017.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2014",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2013",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2012",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2011",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2010",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F3",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F1",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04EF",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04EB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04EA",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04E9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04E8",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04E7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04E6",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D8",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D2",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04AF",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04AA",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u045E",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0459",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0451",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0444",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0443",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u043E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u043B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0435",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0430",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0421",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u041E",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u041B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0410",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0409",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0404",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ";",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ":",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "-",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10095.var.accented",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2026",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04B2",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0473",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0472",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u044D",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0442",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0434",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0425",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0414",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ".",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    g2: "hyphenminus",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0442",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0434",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: ",",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04F5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04B9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04B7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0447",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: ".",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10065.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04B9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04B7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    g2: "hyphenminus",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\uF6BC",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\uF6BB",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\uF6BA",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u201D",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2019",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2014",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2013",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2012",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2011",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2010",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0459",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u043B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u041B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0409",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "-",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u201C",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0434",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    g2: "hyphenminus",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\uF6BC",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\uF6BB",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\uF6BA",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2014",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2013",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2012",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2011",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2010",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u043B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u041B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0409",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "-",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0434",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    g2: "afii10037.var.accented",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04F2",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04F0",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04EE",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04AE",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0423",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u040E",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0402",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0497",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u201D",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u2019",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04DF",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0499",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0437",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u04DC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u0496",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u0416",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u2026",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04B2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04AA",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0442",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u043C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0434",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0431",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0425",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0421",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u041C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0414",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: ":",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: ".",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    g2: "afii10037.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04F2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04F0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04EE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0423",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u040E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0442",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "\u0457",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    g2: "afii10085.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04F3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04F1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04EF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0443",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0402",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0497",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10085.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04EF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04AF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0443",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\uF6BC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\uF6BB",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\uF6BA",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u2014",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u2013",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u2012",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u2011",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u2010",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "-",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0459",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0442",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0434",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    g2: "hyphenminus",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0442",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0434",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    g2: "afii10037.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    g2: "afii10017.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u201D",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u2019",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04F2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04F0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04EE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04D2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04D0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04AE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0423",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0410",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u040E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u041C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0414",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0474",
    u2: ";",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0474",
    u2: ",",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0474",
    u2: "\u2026",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0474",
    u2: ":",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0474",
    u2: ".",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0475",
    u2: ",",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0475",
    u2: "\u2026",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0475",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10096.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10093.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10085.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10074.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10070.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10065.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10037.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10032.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10017.var.accented",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u201D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2019",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F3",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F1",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F0",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EF",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EE",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EA",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04DF",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04DE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D2",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D0",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AE",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04A3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0499",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0498",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0453",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0451",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0449",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0448",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0443",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0440",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0439",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0438",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0437",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0435",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0432",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0430",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u042D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0423",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0422",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u041E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u041B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0417",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0410",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u040E",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: ",",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10071.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10097.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10095.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10080.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10049.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10047.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2122",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2026",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F5",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EB",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E9",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E7",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04DD",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C4",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B9",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B3",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AF",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AB",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u049D",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u049B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0497",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0473",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0472",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045E",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0458",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0457",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0456",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0454",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044F",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044D",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044A",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0447",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0446",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0445",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0444",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0442",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0441",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043F",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043E",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043C",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043A",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0436",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0434",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u042F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u042A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u041C",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0414",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u040B",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0409",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0404",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0402",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: ":",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: ".",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u2026",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04AA",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0442",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u043C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0434",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0431",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0425",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0421",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u041C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0414",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: ":",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: ".",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10071.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10097.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10095.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10080.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10049.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10047.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u2122",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u2026",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u201C",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04F5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04EB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04E9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04E7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04E5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04E3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04DD",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04C4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04B9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04B7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04B3",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04AF",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04AB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u049D",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u049B",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0497",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0473",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0472",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u045E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0458",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0457",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0456",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0454",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u044F",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u044D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u044A",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0447",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0445",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0444",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0442",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0441",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u043E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0436",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0434",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u042F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u042D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u042A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0424",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u041C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0414",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u040B",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0409",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0402",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: ":",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: ".",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u2026",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04B2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04AA",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0442",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u043C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0434",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0431",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0425",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0421",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u041C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0414",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: ":",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: ".",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04F5",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04F4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04AB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0453",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0447",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0441",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0427",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0424",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0404",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0459",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    g2: "afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04D2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04D0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0410",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10085.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10074.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04EF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04C8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04BB",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04A3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0458",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0457",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0452",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0448",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0446",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0443",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0440",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0439",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0438",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0432",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10065.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10032.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04EA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0430",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u041E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10096.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10093.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10049.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10047.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F5",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04C4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u049D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u049B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0453",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0449",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0447",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0441",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u042D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0424",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0404",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\uF6BC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\uF6BB",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\uF6BA",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u2014",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u2013",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u2012",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u2011",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u2010",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "-",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0459",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0442",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0434",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10085.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10074.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10065.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10032.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04EF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04EA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04C8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04BB",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04A3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0458",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0457",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0452",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0448",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0446",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0443",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0440",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0439",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0438",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0432",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0430",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u041E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10096.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10093.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10049.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10047.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F5",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04C4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u049D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u049B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0453",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0449",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0447",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0441",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u042D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0424",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0404",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\uF6BC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\uF6BB",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\uF6BA",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u2014",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u2013",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u2012",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u2011",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u2010",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "-",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0459",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0442",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0434",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04F5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0447",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u0442",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "hyphenminus",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\uF6BC",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\uF6BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\uF6BA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2014",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2013",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2012",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2011",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2010",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: ";",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: ":",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "-",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10097.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10080.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2026",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04F9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04F5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04EB",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04DD",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04C8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04C4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04AF",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04AB",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04A3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u049D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u049B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0497",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0473",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0458",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0457",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0455",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0441",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u043E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u043C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0436",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0434",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0431",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0409",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: ".",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\uF6BC",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\uF6BB",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\uF6BA",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    g2: "afii10071.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    g2: "afii10070.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    g2: "afii10065.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2014",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2013",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2012",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2011",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2010",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04D9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04D7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04D3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04D1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0451",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0441",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0435",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "-",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    g2: "hyphenminus",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0455",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0442",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0434",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: ".",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04BB",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u045B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0452",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0427",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10065.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04D3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04D1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04B9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04B7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B8",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04F4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04B8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04B6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04AF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04AE",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u0427",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BB",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04F5",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04F4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04AB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0453",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0447",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0441",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0427",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0424",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0404",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0459",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10085.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10074.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10065.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10032.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04EF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04EA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04C8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04BB",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AF",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04A3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0458",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0457",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0452",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0448",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0446",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0443",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0440",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0439",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0438",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0432",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0430",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u041E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10096.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10093.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10049.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10047.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F5",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04C4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u049D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u049B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0453",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0449",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0447",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0444",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0441",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u042D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0424",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0404",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\uF6BC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\uF6BB",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\uF6BA",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u2014",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u2013",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u2012",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u2011",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u2010",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "-",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0459",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0442",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0434",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C7",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    g2: "afii10071.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    g2: "afii10085.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    g2: "afii10080.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    g2: "afii10070.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    g2: "afii10065.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    g2: "afii10032.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04F3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04F1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04EF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04EB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04EA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04E8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04E7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04E6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04D9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04D8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04D7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04D3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04D1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04AB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0451",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0444",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0443",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0441",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0435",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0430",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u041E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0404",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    g2: "hyphenminus",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u201C",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u2018",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04F5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04DD",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04AF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04AE",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0497",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0473",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0472",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0436",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0424",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0414",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0402",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: ".",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "*",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u201C",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u2018",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    g2: "afii10071.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    g2: "afii10085.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    g2: "afii10080.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    g2: "afii10070.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    g2: "afii10065.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    g2: "afii10032.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04F3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04F1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04EF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04EB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04EA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04E8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04E7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04E6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04D9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04D8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04D7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04D3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04D1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04AB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0451",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0444",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0443",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0441",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0435",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0430",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u041E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0404",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    g2: "hyphenminus",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u201C",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u2018",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04F5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04DD",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04AF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04AE",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0497",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0473",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0472",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0436",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0424",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0414",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0402",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: ".",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "*",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u201C",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u2018",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u04DC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u0496",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u0416",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u041C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u0416",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u0414",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04F5",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04F4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04E5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04E3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04AB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u049D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u049B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0493",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0491",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0453",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0447",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0441",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0433",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0427",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0424",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0404",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04DD",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0497",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0459",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0436",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    g2: "afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04D2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04D0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0410",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E2",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E4",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u041C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u0416",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u0414",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u041C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0416",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0414",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u041C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u0416",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u0414",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    g2: "afii10097.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    g2: "afii10080.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u2026",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04F9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04F5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04EB",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04DD",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04C8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04C4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04AB",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04A3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u049D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u049B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0497",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0473",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0458",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0457",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0455",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u044F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0441",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u043E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u043C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0436",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0434",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0431",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0409",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: ".",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    g2: "hyphenminus",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0442",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0434",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    g2: "afii10097.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    g2: "afii10080.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u2026",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04F9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04F5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04EB",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04DD",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04C8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04C4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04AB",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04A3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u049D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u049B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0497",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0473",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0458",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0457",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0455",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u044F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0441",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u043E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u043C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0436",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0434",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0431",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0409",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: ".",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    g2: "hyphenminus",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0442",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0434",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    g2: "afii10097.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    g2: "afii10080.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u2026",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04F9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04F5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04EB",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04DD",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04C8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04C4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04AB",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04A3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u049D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u049B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0497",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0473",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0458",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0457",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0455",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u044F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0441",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u043E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u043C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0436",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0434",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0431",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0409",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: ".",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    g2: "hyphenminus",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0442",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0434",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F4",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F8",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u04DD",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u04DC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u04AF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0497",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0496",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0436",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0434",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0416",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0414",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u040B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0409",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u04DD",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u04DC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u04AF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0497",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0496",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0436",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0434",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0416",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0414",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u040B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0409",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u04DD",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u04DC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u04AF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0497",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0496",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0436",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0434",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0416",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0414",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u040B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0409",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u04DD",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u04DC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u04AF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0497",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0496",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0436",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0434",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0416",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0414",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u040B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0409",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u04DD",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u04DC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u04AF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0497",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0496",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0436",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0434",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0416",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0414",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u040B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0409",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "Q",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "J",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10071.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10096.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10093.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10085.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10074.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10070.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10065.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10047.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10017.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F3",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04EF",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04DE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D3",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D1",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04C8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04AF",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04A3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0498",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0493",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0491",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0459",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0457",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0456",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0453",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0451",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u044E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u044C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u044B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0449",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0448",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0446",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0443",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0439",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0438",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0435",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0433",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0432",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0430",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u042D",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u041B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0417",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0410",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "w",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "s",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "r",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "o",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "g",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "e",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "d",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "c",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "a",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "A",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ",",
    k: 188
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10080.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04EB",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04E9",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04E7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04AB",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0473",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0454",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0444",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0441",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043C",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0434",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u041C",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0414",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0409",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "q",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "J",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ".",
    k: 177
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0422",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u040B",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0402",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "Y",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "W",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "V",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "T",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "A",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "Q",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "J",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "A",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "J",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10085.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10047.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10037.var.accented",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10017.var.accented",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F2",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F1",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F0",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04EF",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04EE",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04DE",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04D2",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04D0",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04AF",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04AE",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0498",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u045E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0443",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u042D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0423",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0422",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0417",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0410",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u040E",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0402",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "Y",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "W",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "T",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F5",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F4",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B9",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B8",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B7",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B6",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04AA",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0447",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0442",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0427",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0424",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0421",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    g2: "afii10071.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    g2: "afii10085.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    g2: "afii10080.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    g2: "afii10070.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    g2: "afii10065.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    g2: "afii10032.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04F3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04F1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04EF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04EB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04EA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04E8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04E7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04E6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04D9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04D8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04D7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04D3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04D1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04AB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0451",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0444",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0443",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0441",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0435",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0430",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u041E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0404",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    g2: "hyphenminus",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u201C",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u2018",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04F5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04DD",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04AF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04AE",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0497",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0473",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0472",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0436",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0424",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0414",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0402",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: ".",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "*",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10026.var.accented",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u041C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u0416",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u0414",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    g2: "afii10097.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    g2: "afii10080.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u2026",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04F9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04F5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04EB",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04DD",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04C8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04C4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04AB",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04A3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u049D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u049B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0497",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0473",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0458",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0457",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0456",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0455",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u044F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u044A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0442",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0441",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u043E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u043C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0436",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0434",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0431",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0409",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: ".",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10045.var.accented",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u201D",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u2019",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u2122",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u201C",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u2018",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0416",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0414",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u201D",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u2019",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u201C",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u2018",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u041C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0416",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0414",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10049.var.accented",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u201C",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u2018",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u04DC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u0496",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u0416",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u2019",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    g2: "hyphenminus",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0442",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0434",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u201D",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u2019",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04B3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0445",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u201D",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u2019",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04DF",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0499",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0437",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u04DC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u0496",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u0416",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10071.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10096.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10093.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10085.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10080.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10074.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10070.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10065.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10017.var.accented",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04F9",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04F3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04F1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04EF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04EB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04DF",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D9",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D7",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D2",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D0",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04C8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04AB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04A3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0499",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0493",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0491",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u045F",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u045C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u045A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0459",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0458",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0457",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0456",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0454",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0453",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0451",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0449",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0448",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0446",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0444",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0443",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0441",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0440",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043F",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043B",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0439",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0438",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0437",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0435",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0433",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0432",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0430",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u041B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0410",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0409",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: ",",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10097.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10095.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u2026",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04F5",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04DD",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04B9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04B7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0497",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0473",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044F",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0447",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0442",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043C",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0436",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0434",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0431",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: ".",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CD",
    u2: ",",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CD",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CD",
    u2: ".",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u04DD",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u04DC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u04AF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0497",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0496",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0436",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0434",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0416",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0414",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u040B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0409",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u04DD",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u04DC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u04AF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0497",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0496",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0436",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0434",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0416",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0414",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u040B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0409",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u04DD",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u04DC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u04AF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0497",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0496",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0436",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0434",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0416",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0414",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u040B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0409",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    g2: "afii10085.var.accented",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    g2: "afii10017.var.accented",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04F3",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04F1",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04EF",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04D2",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04D0",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0443",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0422",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0410",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0402",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "T",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "A",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04DD",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04DC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04B2",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04AF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0497",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0496",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u045E",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0442",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0436",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0434",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0425",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0416",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0414",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u040B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0409",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "comma,period",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "C",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "G",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "S",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "T",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "W",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "Y",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "G",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "O",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "quoteright,quotedblright",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "Z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "quoteright,quotedblright",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "Z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "quoteright,quotedblright",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "A",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Z",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "S",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "w",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "U",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "a",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "c",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "d",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "e",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "g",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "o",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "s",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "u",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "G",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "O",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "S",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "T",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "w",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "quoteright,quotedblright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "A",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "z",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "quoteright,quotedblright",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "S",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "T",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "W",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "Y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "comma,period",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "T",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "Y",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "z",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "a",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "c",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "d",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "e",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "g",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "o",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "s",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "u",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "colon,semicolon",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "h,n",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "r",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U",
    g2: "Z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U",
    g2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "G",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "O",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "y",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "d",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "e",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "g",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "o",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "h,n",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "r",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "comma,period",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "S",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "w",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "y",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "A",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "z",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "a",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "c",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "d",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "e",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "g",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "o",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "s",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "u",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "colon,semicolon",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "h,n",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "r",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "comma,period",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "G",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "O",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "S",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "T",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "V",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "W",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "w",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "z",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "a",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "c",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "d",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "e",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "g",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "o",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "s",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "u",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "colon,semicolon",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "h,n",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "r",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "G",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "O",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "S",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "w",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "a",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "c",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "d",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "e",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "g",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "o",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "u",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "T",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "Y",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "quoteright,quotedblright",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "Y",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "w",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "w",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "C",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "G",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "O",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "w",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "y",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "quoteright,quotedblright",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "t",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "i",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "T",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "Y",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "A",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "d",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "e",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "g",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "o",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "s",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "u",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l",
    g2: "z",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "Y",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "w",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "Y",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "quoteright,quotedblright",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "z",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "comma,period",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "O",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "T",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "Y",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "w",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "y",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "a",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "c",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "d",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "e",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "g",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "s",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "t",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "u",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "Y",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "w",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "quoteright,quotedblright",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "G",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "O",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "w",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "y",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "t",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u",
    g2: "Y",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u",
    g2: "w",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u",
    g2: "y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "comma,period",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "Y",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "z",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "a",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "c",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "d",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "e",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "g",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "o",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "s",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "t",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "u",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "comma,period",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "Y",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "a",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "o",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "t",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "u",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "W",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "Y",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "w",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "y",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "a",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "d",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "t",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "u",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "T",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "W",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "afii10051,afii10060,afii10036",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period",
    g2: "Y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "A",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10058,afii10029",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10077,afii10106",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "comma,period",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10058,afii10029",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10077,afii10106",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "quoteright,quotedblright",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10051,afii10060,afii10036",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "comma,period",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "quoteright,quotedblright",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "colon,semicolon",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10051,afii10060,afii10036",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10058,afii10029",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10077,afii10106",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10082,afii10105",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10099,afii10108,uni04BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10082,afii10105",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10099,afii10108,uni04BB",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "quoteright,quotedblright",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "quoteright,quotedblright",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "comma,period",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "quoteright,quotedblright",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10058,afii10029",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10077,afii10106",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10082,afii10105",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10099,afii10108,uni04BB",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10051,afii10060,afii10036",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10058,afii10029",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "quoteright,quotedblright",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10067,afii10073,uni0499,uni04DF",
    g2: "afii10051,afii10060,afii10036",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10067,afii10073,uni0499,uni04DF",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10067,afii10073,uni0499,uni04DF",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10067,afii10073,uni0499,uni04DF",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "comma,period",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "colon,semicolon",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10051,afii10060,afii10036",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10058,afii10029",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10077,afii10106",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "quoteright,quotedblright",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10051,afii10060,afii10036",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10077,afii10106",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074,afii10075,afii10079,afii10081,afii10089,afii10090,afii10093,afii10097,afii10193,uni04A3,uni04B7,uni04B9,uni04BB,uni04C8,uni04E3,uni04E5,uni04F5,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10097.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074,afii10075,afii10079,afii10081,afii10089,afii10090,afii10093,afii10097,afii10193,uni04A3,uni04B7,uni04B9,uni04BB,uni04C8,uni04E3,uni04E5,uni04F5,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10097.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10083,afii10101,uni04AB",
    g2: "afii10051,afii10060,afii10036",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10083,afii10101,uni04AB",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10083,afii10101,uni04AB",
    g2: "afii10077,afii10106",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "comma,period",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "quoteright,quotedblright",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10058,afii10029",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10051,afii10060,afii10036",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10060,uni04BA",
    g2: "afii10051,afii10060,afii10036",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10060,uni04BA",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10060,uni04BA",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 21
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuturaCyrillicMedium);
export default __webpack_public_path__ + "static/media/FuturaCyrillicMedium.38ea20a7928176119a1475f5c475171f.svg";
export { ForwardRef as ReactComponent };